import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
  useLayoutEffect,
} from "react";
import { Trans,useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
// import { confirmAlert } from "react-confirm-alert";
import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Spin,
  Tooltip,
  Typography,
  Pagination,
  Collapse,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import axios from "axios";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import scan_check_green from "../../image/scan_check_green.png";
import wrongicon from "../../image/wrongicon.png";
import scan_unchecked_red from "../../image/scan_unchecked_red.png";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";

import {
  ErrorNotificationMsg,
  // ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import BulkPackageUpload from "./BulkPackageUpload";

import {
  DownloadOutlined,
  EnvironmentOutlined,
  EyeOutlined,
  FilterOutlined,
  InsertRowLeftOutlined,
  PrinterFilled,
  UndoOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { authUserData } from "../../utils/Helper";
import DriverAssignment from "./DriverAssignment";
import SelectRouteModal from "./SelectRouteModal";
import MultipleConfirmDriverAssignment from "./MultipleConfirmDriverAssignment";
import BulkPackageUploadExcel from "./BulkPackageUploadExcel";

import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";
import PackageViewForDepoManager from "../DepoManager/PackageViewForDepoManager";
import { VariableSizeGrid as Grid } from "react-window";
import ResizeObserver from "rc-resize-observer";
import PropTypes from "prop-types";

const { Option } = Select;
const { Panel } = Collapse;

// Move Google Maps libraries array outside the component
const GOOGLE_MAP_LIBRARIES = ["places"];

// Custom vertical scrollbar overlay component
const VerticalScrollbar = ({ height, contentHeight, scrollTop, onScroll }) => {
  const thumbHeight = Math.max((height / contentHeight) * height, 48);
  const maxScrollTop = contentHeight - height;
  const thumbTop = (scrollTop / maxScrollTop) * (height - thumbHeight) || 0;


  const thumbRef = useRef();
  const dragging = useRef(false);
  const dragStartY = useRef(0);
  const dragStartScroll = useRef(0);

  const handlePointerMove = (e) => {
    if (!dragging.current) return;
    const deltaY = e.clientY - dragStartY.current;
    const newScrollTop = Math.min(
      Math.max(
        dragStartScroll.current +
          (deltaY / (height - thumbHeight)) * maxScrollTop,
        0
      ),
      maxScrollTop
    );
    onScroll(newScrollTop);
  };

  const handlePointerUp = (e) => {
    dragging.current = false;
    document.body.style.userSelect = "";
    if (thumbRef.current) {
      thumbRef.current.releasePointerCapture(e.pointerId);
      thumbRef.current.removeEventListener("pointermove", handlePointerMove);
      thumbRef.current.removeEventListener("pointerup", handlePointerUp);
    }
  };

  const handleThumbPointerDown = (e) => {
    dragging.current = true;
    dragStartY.current = e.clientY;
    dragStartScroll.current = scrollTop;
    document.body.style.userSelect = "none";
    if (thumbRef.current) {
      thumbRef.current.setPointerCapture(e.pointerId);
      thumbRef.current.addEventListener("pointermove", handlePointerMove);
      thumbRef.current.addEventListener("pointerup", handlePointerUp);
    }
  };

  if (contentHeight <= height) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        width: 10,
        height,
        background: "rgba(0,0,0,0.02)",
        zIndex: 30,
        borderRadius: 7,
        pointerEvents: "auto",
      }}
    >
      <div
        ref={thumbRef}
        style={{
          position: "absolute",
          left: 2,
          width: 6,
          height: thumbHeight,
          top: thumbTop,
          background: "#F95C19", // orange theme color
          borderRadius: 5,
          cursor: "pointer",
        }}
        onPointerDown={handleThumbPointerDown}
      />
    </div>
  );
};
VerticalScrollbar.propTypes = {
  height: PropTypes.number.isRequired,
  contentHeight: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  onScroll: PropTypes.func.isRequired,
};

// Custom horizontal scrollbar overlay component
const HorizontalScrollbar = ({
  width,
  contentWidth,
  scrollLeft,
  onScroll,
  height = 16,
}) => {
  const thumbWidth = Math.max((width / contentWidth) * width, 48);
  const maxScrollLeft = contentWidth - width;
  const thumbLeft = (scrollLeft / maxScrollLeft) * (width - thumbWidth) || 0;

  const thumbRef = useRef();
  const dragging = useRef(false);
  const dragStartX = useRef(0);
  const dragStartScroll = useRef(0);

  const handlePointerMove = (e) => {
    if (!dragging.current) return;
    const deltaX = e.clientX - dragStartX.current;
    const newScrollLeft = Math.min(
      Math.max(
        dragStartScroll.current +
          (deltaX / (width - thumbWidth)) * maxScrollLeft,
        0
      ),
      maxScrollLeft
    );
    onScroll(newScrollLeft);
  };

  const handlePointerUp = (e) => {
    dragging.current = false;
    document.body.style.userSelect = "";
    if (thumbRef.current) {
      thumbRef.current.releasePointerCapture(e.pointerId);
      thumbRef.current.removeEventListener("pointermove", handlePointerMove);
      thumbRef.current.removeEventListener("pointerup", handlePointerUp);
    }
  };

  const handleThumbPointerDown = (e) => {
    dragging.current = true;
    dragStartX.current = e.clientX;
    dragStartScroll.current = scrollLeft;
    document.body.style.userSelect = "none";
    if (thumbRef.current) {
      thumbRef.current.setPointerCapture(e.pointerId);
      thumbRef.current.addEventListener("pointermove", handlePointerMove);
      thumbRef.current.addEventListener("pointerup", handlePointerUp);
    }
  };

  if (contentWidth <= width) return null;

  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        bottom: 0,
        height: height,
        width,
        background: "rgba(0,0,0,0.02)",
        zIndex: 30,
        borderRadius: 7,
        pointerEvents: "auto",
      }}
    >
      <div
        ref={thumbRef}
        style={{
          position: "absolute",
          top: 2,
          height: height - 4,
          width: thumbWidth,
          left: thumbLeft,
          background: "#F95C19", // orange theme color
          borderRadius: 5,
          cursor: "pointer",
        }}
        onPointerDown={handleThumbPointerDown}
      />
    </div>
  );
};
HorizontalScrollbar.propTypes = {
  width: PropTypes.number.isRequired,
  contentWidth: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  onScroll: PropTypes.func.isRequired,
  height: PropTypes.number,
};

const VirtualizedTable = ({
  columns,
  data,
  selectedRow,
  setSelectedRow,
  rowKey,
  height = 600,
  width = 1200, // will be overridden by totalTableWidth
  rowHeight = 54,
  headerHeight = 54,
  onRowClick,
  customCellRender,
  loading = false,
  calculateTotalPrice, // <-- add this
  sortState, // <-- add this
  setSortState, // <-- add this
  gridRef,
  setScrollPosition,
  scrollPosition,
}) => {
  const [containerWidth, setContainerWidth] = useState(width);
  const headerRef = useRef();

  // Reset grid layout when columns change to fix alignment
  useEffect(() => {
    if (gridRef.current && gridRef.current.resetAfterColumnIndex) {
      gridRef.current.resetAfterColumnIndex(0, true);
    }
  }, [columns]);

  // Move these up so showScrollbarSpacer is available before columnsWithSelection
  const rowCount = data.length;
  const contentHeight = rowCount * rowHeight;
  const SCROLLBAR_WIDTH = 10;
  const showScrollbarSpacer = contentHeight > height - headerHeight;

  // Memoized, non-mutating columns with select-all logic
  const columnsWithSelection = useMemo(() => {
    if (!columns || columns.length === 0) return [];
    // Ensure all columns have a width
    let cols = columns.map((col) => ({ ...col, width: col.width || 120 }));
    if (cols[0].key === "selection") {
      // Select all logic for the header checkbox
      cols[0] = {
        ...cols[0],
        title: () => {
          const allVisibleSelected =
            data.length > 0 &&
            data.every((record) =>
              selectedRow.includes(
                typeof rowKey === "function" ? rowKey(record) : record[rowKey]
              )
            );
          const someVisibleSelected = data.some((record) =>
            selectedRow.includes(
              typeof rowKey === "function" ? rowKey(record) : record[rowKey]
            )
          );
          return (
            <input
              style={{
                width: "16px",
                height: "16px",
                verticalAlign: "middle",
                accentColor: "#fff",
              }}
              type="checkbox"
              checked={allVisibleSelected}
              ref={(el) => {
                if (el)
                  el.indeterminate = !allVisibleSelected && someVisibleSelected;
              }}
              onChange={(e) => {
                if (e.target.checked) {
                  const newKeys = [
                    ...selectedRow,
                    ...data
                      .map((record) =>
                        typeof rowKey === "function"
                          ? rowKey(record)
                          : record[rowKey]
                      )
                      .filter((key) => !selectedRow.includes(key)),
                  ];
                  setSelectedRow(newKeys);
                  calculateTotalPrice(newKeys);
                } else {
                  const visibleKeys = data.map((record) =>
                    typeof rowKey === "function"
                      ? rowKey(record)
                      : record[rowKey]
                  );
                  setSelectedRow(
                    selectedRow.filter((key) => !visibleKeys.includes(key))
                  );
                }
              }}
            />
          );
        },
      };
    }
    // If a scrollbar spacer is present, increase the last column's width slightly
    if (cols.length > 0 && showScrollbarSpacer) {
      cols[cols.length - 1] = {
        ...cols[cols.length - 1],
        width: cols[cols.length - 1].width || 120, // Do not add extra width, use spacer column instead
      };
      // Add a spacer column for the scrollbar
      cols = [
        ...cols,
        {
          key: "scrollbar-spacer",
          width: SCROLLBAR_WIDTH,
          isSpacer: true,
        },
      ];
    }
    return cols;
  }, [
    columns,
    selectedRow,
    setSelectedRow,
    data,
    rowKey,
    calculateTotalPrice,
    showScrollbarSpacer,
  ]);

  const columnCount = columnsWithSelection.length;

  // Adjust getColumnWidth to handle the spacer column
  const getColumnWidth = (index) => columnsWithSelection[index]?.width || 120;
  const getRowHeight = () => rowHeight;

  // Calculate total table width as the sum of all column widths
  const totalTableWidth = columnsWithSelection.reduce(
    (sum, col) => sum + (col.width || 120),
    0
  );

  // Sticky header row
  const headerColumns = columnsWithSelection;
  const renderHeader = () =>
    columnsWithSelection.length === 0 ? null : (
      <div
        style={{
          width: containerWidth,
          overflowX: "hidden",
          overflowY: "visible",
          background: "transparent",
          position: "sticky",
          top: 0,
          zIndex: 2,
        }}
      >
        <div
          ref={headerRef}
          className="virtual-table-header-row"
          style={{
            display: "flex",
            width:
              totalTableWidth + (showScrollbarSpacer ? SCROLLBAR_WIDTH : 0),
            height: 44,
            background: "#F95C19", // Orange header
            borderBottom: "1px solid #e8e8e8",
            alignItems: "center",
            color: "#fff",
            fontWeight: 600,
            borderRadius: "8px 8px 0 0",
            overflow: "hidden",
            willChange: "transform",
            transform: `translateX(-${scrollPosition.left}px)`,
            transition: "none",
          }}
        >
          {headerColumns.map((col, i) =>
            col.isSpacer ? (
              <div
                key="scrollbar-spacer"
                style={{
                  width: SCROLLBAR_WIDTH,
                  minWidth: SCROLLBAR_WIDTH,
                  maxWidth: SCROLLBAR_WIDTH,
                  background: "transparent",
                  border: "none",
                }}
              />
            ) : (
              <div
                key={col.key}
                style={{
                  width: getColumnWidth(i),
                  minWidth: getColumnWidth(i),
                  maxWidth: getColumnWidth(i),
                  fontWeight: 500,
                  padding: "0 10px",
                  display: "flex",
                  alignItems: "center",
                  borderRight:
                    i === headerColumns.length - 1
                      ? "none"
                      : "1px solid #f0f0f0",
                  boxSizing: "border-box",
                  userSelect: "none",
                  cursor: col.sorter ? "pointer" : "default",
                  justifyContent: "flex-start",
                  height: 44,
                  background: "#F95C19",
                  color: "#fff",
                  borderTopLeftRadius: i === 0 ? 8 : 0,
                  borderTopRightRadius: i === headerColumns.length - 1 ? 8 : 0,
                  fontSize: 12,
                  letterSpacing: 0.2,
                  verticalAlign: "middle",
                }}
                onClick={() => {
                  if (!col.sorter) return;
                  let nextOrder = "ascend";
                  if (sortState.key === col.key && sortState.order === "ascend")
                    nextOrder = "descend";
                  else if (
                    sortState.key === col.key &&
                    sortState.order === "descend"
                  )
                    nextOrder = null;
                  setSortState({ key: col.key, order: nextOrder });
                }}
              >
                <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  {typeof col.title === "function" ? col.title() : col.title}
                  {col.sorter && (
                    <span
                      style={{
                        marginLeft: 5,
                        display: "flex",
                        flexDirection: "column",
                        fontSize: 9,
                        justifyContent: "center",
                        alignItems: "center",
                        height: 22,
                        gap: 3,
                      }}
                    >
                      <span
                        style={{
                          color:
                            sortState.key === col.key &&
                            sortState.order === "ascend"
                              ? "#fff"
                              : "#ffd6c2",
                          fontWeight:
                            sortState.key === col.key &&
                            sortState.order === "ascend"
                              ? 700
                              : 400,
                          lineHeight: 1,
                          height: 6,
                          display: "block",
                        }}
                      >
                        ▲
                      </span>
                      <span
                        style={{
                          color:
                            sortState.key === col.key &&
                            sortState.order === "descend"
                              ? "#fff"
                              : "#ffd6c2",
                          fontWeight:
                            sortState.key === col.key &&
                            sortState.order === "descend"
                              ? 700
                              : 400,
                          lineHeight: 1,
                          height: 6,
                          display: "block",
                        }}
                      >
                        ▼
                      </span>
                    </span>
                  )}
                </span>
              </div>
            )
          )}
        </div>
      </div>
    );

  // Cell renderer for Grid
  const Cell = ({ columnIndex, rowIndex, style }) => {
    const col = columnsWithSelection[columnIndex];
    if (!col || col.isSpacer) return null;
    const row = data[rowIndex];
    if (col.key === "selection") {
      const key = typeof rowKey === "function" ? rowKey(row) : row[rowKey];
      const checked = selectedRow.includes(key);
      return (
        <div
          style={{
            ...style,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #f0f0f0",
            background: rowIndex % 2 === 0 ? "#fff" : "#fafafa",
            boxSizing: "border-box",
            padding: "0 12px",
            height: 40,
            minHeight: 40,
          }}
        >
          <input
            type="checkbox"
            checked={checked}
            style={{
              width: 16,
              height: 16,
              accentColor: "#F95C19",
              verticalAlign: "middle",
            }}
            onChange={() => {
              let newSelectedRowKeys;
              if (checked) {
                newSelectedRowKeys = selectedRow.filter((k) => k !== key);
              } else {
                newSelectedRowKeys = [...selectedRow, key];
              }
              setSelectedRow(newSelectedRowKeys);
              calculateTotalPrice(newSelectedRowKeys);
            }}
          />
        </div>
      );
    }
    // Always use customCellRender for non-selection columns
    const custom = customCellRender(col, row, rowIndex);
    const isStickyActionColumn = col.key === "operation"; // Your Action column key
    return (
      <div
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #f0f0f0",
          background: rowIndex % 2 === 0 ? "#fff" : "#fafafa",
          boxSizing: "border-box",
          padding: "0 10px",
          height: 40,
          minHeight: 40,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: 14,
          letterSpacing: 0.1,
          transition: "background 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#fff3eb")}
        onMouseLeave={(e) =>
          (e.currentTarget.style.background =
            rowIndex % 2 === 0 ? "#fff" : "#fafafa")
        }
      >
        {custom}
      </div>
    );
  };

  Cell.propTypes = {
    columnIndex: PropTypes.number.isRequired,
    rowIndex: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
  };

  console.log("VirtualizedTable loading:", loading);

  // Handler to sync custom scrollbar with grid
  const handleCustomScrollbarScroll = (newScrollTop) => {
    if (gridRef.current && gridRef.current.scrollTo) {
      gridRef.current.scrollTo({ scrollTop: newScrollTop });
    }
  };

  // Handler to sync custom horizontal scrollbar with grid and header
  const handleCustomHorizontalScrollbarScroll = (newScrollLeft) => {
    const maxScrollLeft = Math.max(0, totalTableWidth - containerWidth);
    const clampedScrollLeft = Math.max(
      0,
      Math.min(newScrollLeft, maxScrollLeft)
    );
    if (gridRef.current && gridRef.current.scrollTo) {
      gridRef.current.scrollTo({ scrollLeft: clampedScrollLeft });
    }
    if (headerRef.current) {
      headerRef.current.style.transform = `translateX(-${clampedScrollLeft}px)`;
    }
  };

  return (
    <ResizeObserver
      onResize={({ width: newWidth }) => setContainerWidth(newWidth)}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          minHeight: height,
          height,
          background: "#fff",
          border: "1px solid #f0f0f0",
          borderRadius: 4,
          overflow: "hidden",
          paddingBottom: 14, // reserve space for horizontal scrollbar
        }}
      >
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height,
              background: "rgba(0,0,0,0.2)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "all",
            }}
          >
            <Spin />
          </div>
        )}
        {renderHeader()}
        <Grid
          ref={gridRef}
          columnCount={columnCount}
          columnWidth={getColumnWidth}
          height={height - headerHeight}
          rowCount={rowCount}
          rowHeight={getRowHeight}
          width={containerWidth}
          onScroll={({ scrollLeft, scrollTop }) => {
            const maxScrollLeft = Math.max(0, totalTableWidth - containerWidth);
            const clampedScrollLeft = Math.max(
              0,
              Math.min(scrollLeft, maxScrollLeft)
            );
            setScrollPosition &&
              setScrollPosition({ left: clampedScrollLeft, top: scrollTop });
            if (headerRef.current) {
              headerRef.current.style.transform = `translateX(-${clampedScrollLeft}px)`;
            }
          }}
        >
          {Cell}
        </Grid>
        {/* Custom always-visible vertical scrollbar overlay */}
        <VerticalScrollbar
          height={height - headerHeight}
          contentHeight={contentHeight}
          scrollTop={scrollPosition.top}
          onScroll={handleCustomScrollbarScroll}
        />
        {/* Absolutely position the horizontal scrollbar at the bottom */}
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            height: 10,
            zIndex: 30,
            background: "transparent",
          }}
        >
          <div style={{ pointerEvents: "auto", height: "100%" }}>
            <HorizontalScrollbar
              width={containerWidth}
              contentWidth={totalTableWidth}
              scrollLeft={scrollPosition.left}
              onScroll={handleCustomHorizontalScrollbarScroll}
              height={10}
            />
          </div>
        </div>
      </div>
    </ResizeObserver>
  );
};

VirtualizedTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  selectedRow: PropTypes.array.isRequired,
  setSelectedRow: PropTypes.func.isRequired,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  height: PropTypes.number,
  width: PropTypes.number,
  rowHeight: PropTypes.number,
  headerHeight: PropTypes.number,
  onRowClick: PropTypes.func,
  customCellRender: PropTypes.func,
  loading: PropTypes.bool,
  calculateTotalPrice: PropTypes.func,
  sortState: PropTypes.object.isRequired, // <-- add this
  setSortState: PropTypes.func.isRequired, // <-- add this
  gridRef: PropTypes.object,
  setScrollPosition: PropTypes.func,
  scrollPosition: PropTypes.object,
};

const ScannedPackageList = () => {
  const { t } = useTranslation();
  const { Title } = Typography;
  const [form] = Form.useForm();
  const [driverForm] = Form.useForm();
  
  const latestSearchTerm = useRef("");
  const hasPermission = authUserData()?.group[0]?.name;
  console.log("User Permission Group:", hasPermission);
  const auth_package_columns = authUserData()?.packages_columns;
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";
  const PickupPointId = authUserData()?.pickup_point
    ? authUserData()?.pickup_point
    : "";
  const WarehouseId = authUserData()?.warehouse
    ? authUserData()?.warehouse
    : "";

  const { Search } = Input;
  const [isModalVisibleHAWB, setIsModalVisibleHAWB] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnFilterLoading, setBtnFilterLoading] = useState(false);
  const [isModalVisiblePackageDetails, setIsModalVisiblePackageDetails] =
    useState(false);
  const [hawbData, setHawbData] = useState(null);
  const [packageDetailsView, setPackageDetailsView] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [routeIds, setRouteIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSuburb, setLoadingSuburb] = useState(false);
  const [postalList, setPostalList] = useState([]);
  const [loadingPostal, setLoadingPostal] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [loadingKeys, setLoadingKeys] = useState([]); // Track keys being updated
  const record = selectedRow.length > 0 ? selectedRow[0] : null;
  const [employeeList, setEmployeeList] = useState([]);
  const [disableCheckboxes, setDisableCheckboxes] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [newPackageAdded, setNewPackageAdded] = useState(false);

  const [packageId, setpackageId] = useState(null);
  const [zones, setZones] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [states, setStates] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [driverList, setDriverList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleRoute, setIsModalVisibleRoute] = useState(false);
  // const [showViewOptimizeButton, setShowViewOptimizeButton] = useState(false);
  // const [showOptimizeButton, setShowOptimizeButton] = useState(false);
  // const [showAddRouteButton, setShowAddRouteButton] = useState(true);

  const [selectedRecords, setSelectedRecords] = useState([]);
  const [checked, setChecked] = useState(false);
  const [checkedPickedUp, setCheckedPickedUp] = useState(false);
  const [checkedRouted, setCheckedRouted] = useState("False");

  const formRef = useRef();

  // 1. Add sortState to PackageList
  const [sortState, setSortState] = useState({ key: null, order: null });

  const handleOkHAWB = () => {
    setIsModalVisibleHAWB(false);
  };
  const handleCancelHAWB = () => {
    setIsModalVisibleHAWB(false);
  };
  const handleOkPackageDetails = () => {
    // setIsModalVisiblePackageDetails(false);
  };
  const handleModalClosePackageDetails = () => {
    setIsModalVisiblePackageDetails(false);
  };

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 300,
    search: "",
    total: 0,
  });
  const intialFilter = {
    state: "",
    zone_id: [],
    suburb_id: [],
    postcode_name: [],
    // zone:"",
    company: "",
    unrouted: "",
    is_scanned: "",
    is_picked_up: "",
    driver_id: "",
    company_id: "",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);

  const updateDriverAssignment = (
    packageId,
    driverId,
    newAssignedToId,
    driverName
  ) => {
    console.log(
      packageId,
      driverId,
      newAssignedToId,
      driverName,
      "Package ID, Driver ID, New Assigned To ID, Driver Name"
    );

    setEmployeeList((prevState) =>
      prevState.map((item) =>
        item.id === packageId
          ? {
              ...item,
              assigned_to_id: newAssignedToId,
              assigned_to: { id: driverId, name: driverName }, // Ensure both id and name are updated
            }
          : item
      )
    );
  };
  useEffect(() => {
    if (
      auth_package_columns.length > 0 &&
      !(
        auth_package_columns.length === 1 &&
        auth_package_columns[0] === "operation"
      )
    ) {
      setCheckedList(auth_package_columns);
    }
  }, []);
  useEffect(() => {
    let canceled = false;
    const getEmployeeList = async () => {
      setLoading(true);

      // Merge state and stateFilter objects
      const ordering =
        sortState.key && sortState.order
          ? (sortState.order === "descend" ? "-" : "") + sortState.key
          : "-id";
      const queryParamsObject = {
        ...state,
        // start_date: startDate || null,
        // end_date: endDate || null,
        is_scanned: checked || null,
        is_picked_up: checkedPickedUp || null,
        unrouted:
          checkedRouted === "False"
            ? ""
            : null || checkedRouted === "True"
            ? "True"
            : null,
        state: stateFilter?.state || null,
        driver_id: stateFilter?.driver_id || null,
        company_id: stateFilter?.company_id || null,
        page: state.page,
        ordering, // <-- use the computed ordering
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
        status: "Received in Depo",
      };

      // Filter out null or undefined values
      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      const payload = {
        // zone_id: stateFilter?.zone_id || [],
        // suburb_id: stateFilter?.suburb_id || [],
        // postcode_name: stateFilter?.postcode_name || [],
        start_date: startDate || null,
        end_date: endDate || null,
        is_supervisor:true,
        ...(hasPermission === "Supervisor"
          ? { suburb_ids: stateFilter?.suburb_id || [] }
          : { suburb_id: stateFilter?.suburb_id || [] }),
          ...(hasPermission === "Supervisor"
            ? { pincode_ids: stateFilter?.postcode_name || [] }
            : { postcode_name: stateFilter?.postcode_name || [] }),
            ...(hasPermission === "Supervisor"
              ? { zone_ids: stateFilter?.zone_id || [] }
              : { zone_id: stateFilter?.zone_id || [],}),
        
      };

      try {
        const url =
  hasPermission === "Supervisor"
    ? `package-model/filtered-list/?company_id=${CompanyId}&pickup_point_id=${PickupPointId}&warehouse_id=${WarehouseId}&is_picked_up=true&${queryParams}`
    : `package-model/?company_id=${CompanyId}&pickup_point_id=${PickupPointId}&warehouse_id=${WarehouseId}&is_picked_up=true&${queryParams}`;
        // const apiResponse = await patchRequest(
        //   `package-model/?company_id=${CompanyId}&pickup_point_id=${PickupPointId}&warehouse_id=${WarehouseId}&is_picked_up=${true}&${queryParams}`,
        //   payload
        // );
        const apiResponse = await patchRequest(url, payload);
  if (canceled || state.search !== latestSearchTerm.current) return;
        if (apiResponse.data.results.success) {
          setEmployeeList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
          setBtnFilterLoading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
    ErrorNotificationMsg(t("Error fetching package list"));
  }
        setBtnFilterLoading(false);
      } finally {
     if (!canceled) setLoading(false);
        setBtnFilterLoading(false);
      }
    };

    getEmployeeList();

    // Cleanup function to mark this effect as canceled
    return () => {
      canceled = true;
    };
  }, [state, newPackageAdded, reload, t, sortState]);



  
  const handleHawbClick = async (record) => {
    try {
      const response = await getRequest(
        `package-model/get-package-by-ids/${record}`
      );
      if (response.data.success) {
        // const total = response.data.data.reduce(
        //   (sum, pkg) => sum + (pkg.price || 0) * 1.1, // Add 10% GST to each
        //   0
        // );

        setHawbData(response.data.data); // Set the data of the clicked row to display in the modal
        setIsModalVisibleHAWB(true);
      }
    } catch (error) {
      console.error("Error fetching package data", error);
      ErrorNotificationMsg(t("error_fetching_prices"));
      setIsModalVisibleHAWB(false);
    }
    // Open the modal
  };

  useEffect(() => {
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    authUserData()?.state
      ? getzoneByState(authUserData()?.state)
      : getzoneByState(1);

    getDriverName();
    getCompanyName();
  }, []);
  const [checkedList, setCheckedList] = useState([
    "parcel_no",
    "order_no",
    "created_at",
    "customer_phone",
    // "customer_email",
    "is_scanned",
    "is_picked_up",
    "suburb",
    "status",
    "zone",
    "state",
    "postcode",
    "assigned_to",
    "hawb",
    "unrouted",
    "route_name",
    // "latitude",
    // "longitude",
    "sequence_no",
    "customer_code",
    "customer_name",
    "company",
    "customer_address",
    // "description_of_goods",
    "count",
    // "landed",
    "weight",
    "price",
    // "shipper_code",
    // "shipper_name",
    // "shipper_address",
    // "shipper_city",
    // "shipper_state",
    // "shipper_postcode",
    // "shipper_country",
    // "origin",
    // "port",
    // "total_value",
    // "goods_currency",
    // "sac",
    // "fr_reference",
    // "sub_master",
    // "pkg_type",
    // "cyber_vendor_account",
    // "customs_code",
    "operation",
  ]);
  const changeStatus = async (id, value) => {
    setLoading(true);
    await patchRequest(`package-status/${id}/`, { status: value })
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        setReload(!reload);
        clearDateFromAPI();
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleResidentSelectChangeStatusFilter = (value) => {
    setSelectedStatus(value); // Store the value directly, not an object
  };

  const handleResidentSelectChange = async (id, status) => {
    // setLoading(true);
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("confirmAlert_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(id, status),
        },
        {
          label: t("confirmAlert_cancel"),

          onClick: () => {
            setLoading(false);
            navigate("/package");
          },
        },
      ],
    });
  };
  const [columns, setColumns] = useState([]);

  const allColumns = [
    { key: "parcel_no", title: "Parcel Number" },
    { key: "order_no", title: "Order Number" },
    { key: "created_at", title: "Schedule Date" },
    { key: "hawb", title: "HAWB" },
    { key: "unrouted", title: "Unrouted" },
    { key: "route_name", title: "Route Name" },
    { key: "sequence_no", title: "Sequence" },
    { key: "is_scanned", title: "Is Scanned" },
    { key: "is_picked_up", title: "Is Picked Up" },
    { key: "status", title: "Status" },
    { key: "suburb", title: "Suburb" },
    { key: "zone", title: "Zone" },
    { key: "state", title: "State" },
    { key: "postcode", title: "Postcode" },
    { key: "assigned_to", title: "Assigned Driver" },
    { key: "latitude", title: "Latitude" },
    { key: "longitude", title: "Longitude" },

    { key: "customer_code", title: "Customer Code" },
    { key: "customer_name", title: "Customer Name" },
    { key: "company", title: "Company" },

    { key: "customer_phone", title: "Customer phone" },
    { key: "customer_email", title: "Customer Email" },
    { key: "customer_address", title: "Customer Address" },
    { key: "description_of_goods", title: "Description of Goods" },
    { key: "count", title: "Count" },
    { key: "landed", title: "Landed" },
    { key: "weight", title: "Weight" },
    { key: "price", title: "Price" },
    { key: "shipper_code", title: "Shipper Code" },
    { key: "shipper_name", title: "Shipper Name" },
    { key: "shipper_address", title: "Shipper Address" },
    { key: "shipper_city", title: "Shipper City" },
    { key: "shipper_state", title: "Shipper State" },
    { key: "shipper_postcode", title: "Shipper Postcode" },
    { key: "shipper_country", title: "Shipper Country" },
    { key: "origin", title: "Origin" },
    { key: "port", title: "Port" },
    { key: "total_value", title: "Total Value" },
    { key: "goods_currency", title: "Goods Currency" },
    { key: "sac", title: "SAC" },
    { key: "fr_reference", title: "FR Reference" },
    { key: "sub_master", title: "Sub Master" },
    { key: "pkg_type", title: "Package Type" },
    { key: "cyber_vendor_account", title: "Cyber Vendor Account" },
    { key: "customs_code", title: "Customs Code" },
    { key: "operation", title: "Action" },
  ];

  const [selectedRecord, setSelectedRecord] = useState(null);

  const handlePackageDetailsClick = async (record) => {
    // setSelectedRecord(record);
    //setIsModalVisible(true);

    try {
      const response = await getRequest(
        `return-parcel/returned-parcel-full-details/?hawb=${record}`
      );
      if (response?.data?.success) {
        setPackageDetailsView(response?.data);
        setIsModalVisiblePackageDetails(true);
      }
    } catch (error) {
      console.log(error);
    }
    // console.log(record, "records222");

    // setPackageDetailsView(record);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
  };

  useEffect(() => {
    console.log("isModalVisiblePackageDetails", isModalVisiblePackageDetails);
  }, [isModalVisiblePackageDetails]);
  useEffect(() => {
    const updatedColumns = [
      // Define columns here
      {
        title: "Company",
        dataIndex: "company_name",
        key: "company",
        sorter: true,
        width: 150,
      },
      {
        title: "HAWB",
        dataIndex: "hawb",
        key: "hawb",
        sorter: true,
        render: (text, record) => (
          <div
            // onClick={() => handleHawbClick(record?.id)} // Add onClick to open modal
            style={{ cursor: "pointer" }}
          >
            {text}
          </div>
        ),
        width: 200,
      },
      {
        title: "Schedule Date",
        dataIndex: "created_at",
        key: "created_at",
        sorter: true,
        width: 150,
        render: (text) => (
          <div className="text-ellipsis">
            {text ? moment(text, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY") : "-"}
          </div>
        ),
      },
      {
        title: "Parcel Number",
        dataIndex: "parcel_no",
        key: "parcel_no",
        sorter: true,
        width: 100,
      },
      {
        title: "Sequence",
        dataIndex: "sequence_no",
        key: "sequence_no",
        sorter: true,
        width: 150,
        render: (text) => (
          <div className="text-ellipsis">
            {text !== undefined && text !== null ? text : 0}
          </div>
        ),
      },

      {
        title: "Is Scanned",
        dataIndex: "is_scanned",
        key: "is_scanned",
        sorter: true,
        width: 120,
        render: (text) => (
          <div className="text-ellipsis">
            {text ? (
              <img
                src={scan_check_green} // Replace with the actual path to the 'Yes' image
                alt="Yes"
                style={{ width: 20, height: 20, Color: "rgba(0, 128, 0, 0.5)" }}
              />
            ) : (
              <img
                src={scan_unchecked_red} // Replace with the actual path to the 'No' image
                alt="No"
                style={{ width: 20, height: 20 }}
              />
            )}
          </div>
        ),
      },
      {
        title: "Is Picked Up",
        dataIndex: "is_picked_up",
        key: "is_picked_up",
        sorter: true,
        width: 120,
        render: (text) => (
          <div className="text-ellipsis">
            {text ? (
              <img
                src={scan_check_green} // Replace with the actual path to the 'Yes' image
                alt="Yes"
                style={{ width: 20, height: 20, Color: "rgba(0, 128, 0, 0.5)" }}
              />
            ) : (
              <img
                src={scan_unchecked_red} // Replace with the actual path to the 'No' image
                alt="No"
                style={{ width: 20, height: 20 }}
              />
            )}
          </div>
        ),
      },
      ...(hasPermission === "Company Admin" ||
      hasPermission === "Pickup Point Manager" ||
      hasPermission === "Depo Manager"
        ? [] // If CompanyId exists, exclude this column
        : [
            {
              title: "Assigned Driver",
              dataIndex: "assigned_to",
              key: "assigned_to",
              sorter: true,
              width: 200,
              render: (assigned_to, record) => {
                return (
                  <DriverAssignment
                    record={record}
                    reload={reload}
                    setSelectedRow={setSelectedRow}
                    setRouteIds={setRouteIds}
                    routeIds={routeIds}
                    setReload={setReload}
                    setState={setState}
                    driverList={driverList}
                    setEmployeeList={setEmployeeList}
                  />
                );
              },
            },
          ]),

      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: true,
        width: 230,
        render: (e, record) => (
          <div>
            <Select
              disabled={
                hasPermission === "Pickup Point Manager" ||
                hasPermission === "Company Admin" ||
                hasPermission === "Depo Manager"
              }
              value={e ? e : record.status}
              className="gridselect"
              onChange={(e) => handleResidentSelectChange(record.id, e)}
              defaultValue={e}
              placeholder={t("pl_select_status")}
            >
              <Option key="Not Scanned" value="Not Scanned">
                Not Scanned
              </Option>
              <Option key="Picked Up" value="Picked Up">
                Picked Up
              </Option>
              <Option key="Received in Depo" value="Received in Depo">
                Received in Depo
              </Option>
              <Option key="Loaded by Driver" value="Loaded by Driver">
                Loaded by Driver
              </Option>
              <Option key="In Transit" value="In Transit">
                In Transit
              </Option>
              <Option key="Delivered" value="Delivered">
                Delivered
              </Option>
              <Option key="Failed Delivery" value="Failed Delivery">
                Failed Delivery
              </Option>
              <Option
                key="Received at Pickup Point"
                value="Received at Pickup Point"
              >
                Received at Pickup Point
              </Option>
              <Option key="RTS- Return to Sender" value="RTS- Return to Sender">
                RTS- Return to Sender
              </Option>
              <Option key="RD- Return to depo" value="RD- Return to depo">
                RD- Return to depo
              </Option>
              <Option key="Damaged" value="Damaged">
                Damaged
              </Option>
              <Option key="Rejected" value="Rejected">
                Rejected
              </Option>
              <Option key="Problem Freight" value="Problem Freight">
                Problem Freight
              </Option>
              <Option key="ATL" value="ATL">
                ATL
              </Option>
              {/* <Option key="Unsafe to Leave" value="Unsafe to Leave">
                Unsafe to Leave
              </Option> */}
              <Option
                key="Received In Perth Depo"
                value="Received In Perth Depo"
              >
                Received In Perth Depo
              </Option>
              <Option
                key="Received In Sydney Depo"
                value="Received In Sydney Depo"
              >
                Received In Sydney Depo
              </Option>
              <Option
                key="Received In Brisbane Depo"
                value="Received In Brisbane Depo"
              >
                Received In Brisbane Depo
              </Option>
              <Option
                key="Received In Canberra Depo"
                value="Received In Canberra Depo"
              >
                Received In Canberra Depo
              </Option>
              <Option
                key="Received In Adelaide Depo"
                value="Received In Adelaide Depo"
              >
                Received In Adelaide Depo
              </Option>
              <Option
                key="Received In Melbourne Depo"
                value="Received In Melbourne Depo"
              >
                Received In Melbourne Depo
              </Option>
            </Select>
          </div>
        ),
      },
      ...(hasPermission === "Pickup Point Manager"
        ? [] // If CompanyId exists, exclude this column
        : [
            {
              title: "Unrouted",
              dataIndex: "unrouted",
              key: "unrouted",
              sorter: true,
              width: 180,
              render: (text) => (
                <div className="text-ellipsis">
                  {text ? (
                    <img
                      src={wrongicon} // Replace with the actual path to the 'Yes' image
                      alt="Yes"
                      style={{
                        width: 20,
                        height: 20,
                        Color: "rgba(0, 128, 0, 0.5)",
                      }}
                    />
                  ) : (
                    "-"
                  )}
                </div>
              ),
            },
          ]),
          ...(hasPermission === "Pickup Point Manager"
            ? []
            : [
                {
                  title: "Route Name",
                  dataIndex: "route_name",
                  key: "route_name",
                  sorter: true,
                  width: 250,
                  render: (text) =>
                    text ? (
                      <span
                        style={{ color: "black", cursor: "pointer" }}
                        onClick={() => navigate(`/route-list?search=${text}`)}
                      >
                        {text}
                      </span>
                    ) : (
                      "-"
                    ),
                },
              ]),
    
      {
        title: "Suburb",
        dataIndex: "suburb_name",
        key: "suburb",
        sorter: true,
        width: 180,
      },

      {
        title: "Run",
        dataIndex: "zone_name",
        key: "zone",
        sorter: true,
        width: 180,
      },
      {
        title: "State",
        dataIndex: "state_name",
        key: "state",
        sorter: true,
        width: 150,
      },
      {
        title: "Postcode",
        dataIndex: "postcode_name",
        key: "postcode",
        sorter: true,
        width: 150,
      },

      {
        title: "Customer Code",
        dataIndex: "customer_code",
        key: "customer_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Name",
        dataIndex: "customer_name",
        key: "customer_name",
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Phone",
        dataIndex: "customer_phone",
        key: "customer_phone",
        // render: (customer_phone) => <>+{customer_phone} </>,
        render: (customer_phone) =>
          customer_phone ? <>+{customer_phone}</> : null,
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Email",
        dataIndex: "customer_email",
        key: "customer_email",
        sorter: true,
        width: 200,

        render: (dataIndex) => (
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textTransform: "none",
            }}
          >
            {dataIndex}
          </div>
        ),
      },
      {
        title: "Customer Address",
        dataIndex: "customer_address",
        key: "customer_address",
        sorter: true,
        width: 200,

        render: (dataIndex) => (
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        ),
      },
      {
        title: "Order Number",
        dataIndex: "order_no",
        key: "order_no",
        sorter: true,
        width: 100,
      },

      {
        title: "Description of Goods",
        dataIndex: "description_of_goods",
        key: "description_of_goods",
        sorter: true,
        width: 150,
      },
      {
        title: "Count",
        dataIndex: "count",
        key: "count",
        sorter: true,
        width: 100,
      },
      {
        title: "Landed",
        dataIndex: "landed",
        key: "landed",
        sorter: true,
        width: 100,
        render: (text) => (
          <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
        ),
      },
      {
        title: "Weight",
        dataIndex: "weight",
        key: "weight",
        sorter: true,
        width: 100,
      },
      {
        title: "Price",
        dataIndex: "price",
        key: "price",
        sorter: true,
        width: 100,
        render: (price) => (price ? `$${price}` : "-"),
      },
      {
        title: "Shipper Code",
        dataIndex: "shipper_code",
        key: "shipper_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper Name",
        dataIndex: "shipper_name",
        key: "shipper_name",
        sorter: true,
        width: 150,
        render: (dataIndex) => (
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        ),
      },
      {
        title: "Shipper Address",
        dataIndex: "shipper_address",
        key: "shipper_address",
        sorter: true,
        width: 200,

        render: (dataIndex) => (
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        ),
      },
      {
        title: "Shipper City",
        dataIndex: "shipper_city",
        key: "shipper_city",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper State",
        dataIndex: "shipper_state",
        key: "shipper_state",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper Postcode",
        dataIndex: "shipper_postcode",
        key: "shipper_postcode",
        sorter: true,
        width: 100,
      },
      {
        title: "Shipper Country",
        dataIndex: "shipper_country",
        key: "shipper_country",
        sorter: true,
        width: 150,
      },
      {
        title: "Origin",
        dataIndex: "origin",
        key: "origin",
        sorter: true,
        width: 150,
        render: (dataIndex) => (
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
        ),
      },
      {
        title: "Port",
        dataIndex: "port",
        key: "port",
        sorter: true,
        width: 150,
      },
      {
        title: "Total Value",
        dataIndex: "total_value",
        key: "total_value",
        sorter: true,
        width: 150,
      },
      {
        title: "Goods Currency",
        dataIndex: "goods_currency",
        key: "goods_currency",
        sorter: true,
        width: 100,
      },
      {
        title: "SAC",
        dataIndex: "sac",
        key: "sac",
        sorter: true,
        width: 100,
        render: (text) => (
          <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
        ),
      },
      {
        title: "FR Reference",
        dataIndex: "fr_reference",
        key: "fr_reference",
        sorter: true,
        width: 150,
      },
      {
        title: "Sub Master",
        dataIndex: "sub_master",
        key: "sub_master",
        sorter: true,
        width: 150,
      },
      {
        title: "Package Type",
        dataIndex: "pkg_type",
        key: "pkg_type",
        sorter: true,
        width: 100,
      },
      {
        title: "Cyber Vendor Account",
        dataIndex: "cyber_vendor_account",
        key: "cyber_vendor_account",
        sorter: true,
        width: 150,
      },
      {
        title: "Customs Code",
        dataIndex: "customs_code",
        key: "customs_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Latitude",
        dataIndex: "coordinates",
        key: "latitude",
        sorter: true,
        render: (coordinates) => coordinates?.latitude || "N/A",
        width: 180,
      },
      {
        title: "Longitude",
        dataIndex: "coordinates",
        key: "longitude",
        sorter: true,
        render: (coordinates) => coordinates?.longitude || "N/A",
        width: 180,
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 130,
        render: (text, record) => (
          <Space>
            {/* <Link to={`/package/view/${btoa(record.id)}`}> */}
            {authUserData()?.warehouse && (
              <EyeOutlined
                onClick={() => handlePackageDetailsClick(record?.hawb)}
              />
            )}

            {/* </Link> */}

            {authUserData()?.permission.includes(
              "package|change_packagemodel"
            ) && (
              <Link to={`/package/edit/${btoa(record.id)}`}>
                <Editicon onClick={() => handleEdit(record.id)} />
              </Link>
            )}
            <Tooltip placement="top" title={"Label Print"}>
              <span onClick={() => handleGenerateLabel(record)}>
                <PrinterFilled style={{ cursor: "pointer" }} />
              </span>
            </Tooltip>
            {authUserData()?.permission.includes(
              "package|change_packagemodel"
            ) &&
              record?.pod && (
                <Tooltip
                  color={colors}
                  placement="left"
                  title={
                    <span style={{ color: "#fff" }}>Download POD Report</span>
                  }
                >
                  <DownloadOutlined
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = record.pod;
                      link.download = "";
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  />
                </Tooltip>
              )}
            {authUserData()?.permission.includes(
              "package|delete_packagemodel"
            ) && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                onConfirm={() => handleArchive(record.id)}
              >
                <Archive style={{ cursor: "pointer" }} />
              </Popconfirm>
            )}
          </Space>
        ),
      },
    ].filter((column) => checkedList.includes(column.key));

    setColumns(updatedColumns);
  }, [checkedList, driverList]);

  const calculateTotalPrice = (Ids) => {
    let selectedIds = [...Ids];
    if (!selectedIds || selectedIds.length === 0) {
      setTotalPrice(0);
      return;
    }

    const selectedPackages = employeeList.filter((pkg) =>
      selectedIds.includes(pkg.id)
    );

    const total = selectedPackages.reduce((sum, pkg) => {
      const basePrice = pkg.price || 0;
      return sum + basePrice * 1.1; // Add 10% GST
    }, 0);
    setTotalPrice(total);
  };

  const handleColumnVisibilityChange = (checkedValues) => {
    // Identify the keys being updated (added or removed)
    const updatingKeys = checkedValues
      .filter((key) => !checkedList.includes(key))
      .concat(checkedList.filter((key) => !checkedValues.includes(key)));

    // Show loader for affected keys
    setLoadingKeys(updatingKeys);

    // Disable all other checkboxes until the action is completed
    // setDisableCheckboxes(true);

    new Promise((resolve) => {
      // Simulate an asynchronous operation or update
      setCheckedList(checkedValues); // Trigger the update
      setTimeout(resolve, 500); // Simulated operation delay (adjust as needed)
    })
      .then(() => {
        // Clear the loading state and re-enable all checkboxes
        setLoadingKeys([]);
        // setDisableCheckboxes(false);
      })
      .catch((error) => {
        console.error("Error in column visibility change:", error);
        setLoadingKeys([]); // Ensure loading state is cleared in case of an error
        // setDisableCheckboxes(false); // Re-enable checkboxes in case of an error
      });
  };

  // const columnMenu = (
  //   <Menu className="packagelistdropdown">
  //     <Menu.Item>
  //       <Checkbox.Group
  //         value={checkedList}
  //         onChange={handleColumnVisibilityChange}
  //       >
  //         <Row>
  //           {allColumns.map((column) => (
  //             <Col span={12} key={column.key}>
  //               <Checkbox
  //                 value={column.key}
  //                 disabled={column.key === "operation"}
  //               >
  //                 {column.title}
  //               </Checkbox>
  //             </Col>
  //           ))}
  //         </Row>
  //       </Checkbox.Group>
  //     </Menu.Item>
  //   </Menu>
  // );

  // Function to convert parcel_no to string and trim it

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
          disabled={loadingKeys.length > 0}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  // disabled={loadingKeys.includes(column.key)} // Disable checkbox if loading
                  disabled={
                    column.key === "operation" || // Always disable the "operation" key
                    (loadingKeys.length > 0 &&
                      !loadingKeys.includes(column.key)) // Disable other checkboxes during loading
                  }
                >
                  {loadingKeys.includes(column.key) ? (
                    <Spin size="small" />
                  ) : (
                    column.title
                  )}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );
  const getTrimmedParcelNo = (parcel_no) => {
    return parcel_no ? parcel_no?.toString().trim() : "";
  };

  const getDriverName = async () => {
    try {
      // setapiLoading(true);
      const response = await getRequest("employee/drivers-list/");

      const { data } = response.data;
      setDriverList(data);
      formRef.current.setFieldsValue(response.data.data);
      // setapiLoading(false);
    } catch (error) {
      // setapiLoading(false);
    }
  };
  const getCompanyName = async () => {
    try {
      // setapiLoading(true);
      const response = await getRequest("company/?no_pagination=true");

      const { data } = response.data;
      setCompanyList(data);
      formRef.current.setFieldsValue(response.data.data);
      // setapiLoading(false);
    } catch (error) {
      // setapiLoading(false);
    }
  };

  const handleDriverFilter = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      driver_id: value,
    }));
  };
  const handleCompanyFilter = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      company_id: value,
    }));
  };

  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const handleStateSelectChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      state: value,
      zone_id: [],
      suburb_id: [],
      postcode_name: [],
    }));
    formRef.current.setFieldsValue({
      zone: undefined,
      // suburb: undefined,
      suburb_id: undefined,
      postcode: undefined,
    });
    setSuburbList([]);
    setPostalList([]);
    setZones([]);
    getzoneByState(value);
  };
  const getzoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "zone/?no_pagination=true&state_id=" + id
    );

    setZones(zoneResponse?.data?.data);
  };

  const handleChangeAssign = () => {
    setIsModalVisible(true); // Open the modal
  };

  const closeModal = () => {
    setIsModalVisible(false); // Close the modal
  };

  const handlezoneChange = (selectedZones) => {
    setStateFilter((prevState) => ({
      ...prevState,
      zone_id: selectedZones,
      suburb_id: [],
      postcode_name: [],
    }));

    formRef.current.setFieldsValue({
      suburb_id: undefined,
      postcode: undefined,
    });
    setSuburbList([]);
    setPostalList([]);
    // getSuburbByzone(selectedZones);
    getPostalByZone(selectedZones);
  };

  const handleSuburbChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      suburb_id: value,
      // postcode_name: [],
      // zone: null,
    }));
  };

  const getPostalByZone = async (zoneIds) => {
    setLoadingPostal(true);
    setLoadingSuburb(true);
    try {
      const payload = { zone_ids: zoneIds }; // Prepare the payload with zoneId array

      // Call both APIs in parallel using Promise.all
      const [postalResponse, suburbResponse] = await Promise.all([
        patchRequest(
          "zone/zone-by-pincode-filter/?no_pagination=True",
          payload
        ),
        patchRequest("zone/zone-by-suburb-filter/?no_pagination=True", payload),
      ]);

      // Handle the response for the postal data
      if (postalResponse?.data?.success) {
        setPostalList(postalResponse?.data?.data);
      }

      // Handle the response for the suburb data
      if (suburbResponse?.data?.success) {
        setSuburbList(suburbResponse?.data?.data); // Assuming you have a function or state to handle suburb data
      }

      setLoadingPostal(false);
      setLoadingSuburb(false);
    } catch (error) {
      ErrorNotificationMsg(t("Error fetching postal or suburb data"));
      setLoadingPostal(false);
      setLoadingSuburb(false);
    }
  };

  const handlePostalChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      postcode_name: value,
    }));
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      driverForm.resetFields(); // Reset the driver form fields
      // setPopConfirmVisible(false); // Close the Popconfirm
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "order_no" && sortOrder === "ascend") {
      sortingEnumKey = "order_no";
    }
    if (sortField === "order_no" && sortOrder === "descend") {
      sortingEnumKey = "-order_no";
    }
    if (sortField === "parcel_no" && sortOrder === "ascend") {
      sortingEnumKey = "parcel_no";
    }
    if (sortField === "parcel_no" && sortOrder === "descend") {
      sortingEnumKey = "-parcel_no";
    }
    if (sortField === "sequence_no" && sortOrder === "ascend") {
      sortingEnumKey = "sequence_no";
    }
    if (sortField === "sequence_no" && sortOrder === "descend") {
      sortingEnumKey = "-sequence_no";
    }

    if (sortField === "hawb" && sortOrder === "ascend") {
      sortingEnumKey = "hawb";
    }
    if (sortField === "hawb" && sortOrder === "descend") {
      sortingEnumKey = "-hawb";
    }
    if (sortField === "unrouted" && sortOrder === "ascend") {
      sortingEnumKey = "unrouted";
    }
    if (sortField === "unrouted" && sortOrder === "descend") {
      sortingEnumKey = "-unrouted";
    }
    if (sortField === "route_name" && sortOrder === "ascend") {
      sortingEnumKey = "route_name";
    }
    if (sortField === "route_name" && sortOrder === "descend") {
      sortingEnumKey = "-route_name";
    }
    if (sortField === "created_at" && sortOrder === "ascend") {
      sortingEnumKey = "created_at";
    }
    if (sortField === "created_at" && sortOrder === "descend") {
      sortingEnumKey = "-created_at";
    }

    if (sortField === "is_scanned" && sortOrder === "ascend") {
      sortingEnumKey = "is_scanned";
    }
    if (sortField === "is_scanned" && sortOrder === "descend") {
      sortingEnumKey = "-is_scanned";
    }
    if (sortField === "is_picked_up" && sortOrder === "ascend") {
      sortingEnumKey = "is_picked_up";
    }
    if (sortField === "is_picked_up" && sortOrder === "descend") {
      sortingEnumKey = "-is_picked_up";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb__area";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb__area";
    }
    if (sortField === "zone" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "postcode" && sortOrder === "ascend") {
      sortingEnumKey = "postcode__pincode";
    }
    if (sortField === "postcode" && sortOrder === "descend") {
      sortingEnumKey = "-postcode__pincode";
    }
    if (sortField === "assigned_to" && sortOrder === "ascend") {
      sortingEnumKey = "assign_package__driver__name";
    }
    if (sortField === "assigned_to" && sortOrder === "descend") {
      sortingEnumKey = "-assign_package__driver__name";
    }
    if (sortField === "latitude" && sortOrder === "ascend") {
      sortingEnumKey = "latitude";
    }
    if (sortField === "latitude" && sortOrder === "descend") {
      sortingEnumKey = "-latitude";
    }
    if (sortField === "longitude" && sortOrder === "ascend") {
      sortingEnumKey = "longitude";
    }
    if (sortField === "longitude" && sortOrder === "descend") {
      sortingEnumKey = "-longitude";
    }
    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }
    if (sortField === "customer_code" && sortOrder === "ascend") {
      sortingEnumKey = "customer_code";
    }
    if (sortField === "customer_code" && sortOrder === "descend") {
      sortingEnumKey = "-customer_code";
    }
    if (sortField === "customer_name" && sortOrder === "ascend") {
      sortingEnumKey = "customer_name";
    }
    if (sortField === "customer_name" && sortOrder === "descend") {
      sortingEnumKey = "-customer_name";
    }
    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_name";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_name";
    }
    if (sortField === "customer_address" && sortOrder === "ascend") {
      sortingEnumKey = "customer_address";
    }
    if (sortField === "customer_address" && sortOrder === "descend") {
      sortingEnumKey = "-customer_address";
    }
    if (sortField === "description_of_goods" && sortOrder === "ascend") {
      sortingEnumKey = "description_of_goods";
    }
    if (sortField === "description_of_goods" && sortOrder === "descend") {
      sortingEnumKey = "-description_of_goods";
    }
    if (sortField === "count" && sortOrder === "ascend") {
      sortingEnumKey = "count";
    }
    if (sortField === "count" && sortOrder === "descend") {
      sortingEnumKey = "-count";
    }
    if (sortField === "landed" && sortOrder === "ascend") {
      sortingEnumKey = "landed";
    }
    if (sortField === "landed" && sortOrder === "descend") {
      sortingEnumKey = "-landed";
    }
    if (sortField === "weight" && sortOrder === "ascend") {
      sortingEnumKey = "weight";
    }
    if (sortField === "weight" && sortOrder === "descend") {
      sortingEnumKey = "-weight";
    }
    if (sortField === "price" && sortOrder === "ascend") {
      sortingEnumKey = "price";
    }
    if (sortField === "price" && sortOrder === "descend") {
      sortingEnumKey = "-price";
    }
    if (sortField === "shipper_code" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_code";
    }
    if (sortField === "shipper_code" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_code";
    }
    if (sortField === "shipper_name" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_name";
    }
    if (sortField === "shipper_name" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_name";
    }
    if (sortField === "shipper_address" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_address";
    }
    if (sortField === "shipper_address" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_address";
    }
    if (sortField === "shipper_city" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_city";
    }
    if (sortField === "shipper_city" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_city";
    }
    if (sortField === "shipper_state" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_state";
    }
    if (sortField === "shipper_state" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_state";
    }
    if (sortField === "shipper_postcode" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_postcode";
    }
    if (sortField === "shipper_postcode" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_postcode";
    }
    if (sortField === "shipper_country" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_country";
    }
    if (sortField === "shipper_country" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_country";
    }
    if (sortField === "origin" && sortOrder === "ascend") {
      sortingEnumKey = "origin";
    }
    if (sortField === "origin" && sortOrder === "descend") {
      sortingEnumKey = "-origin";
    }
    if (sortField === "port" && sortOrder === "ascend") {
      sortingEnumKey = "port";
    }
    if (sortField === "port" && sortOrder === "descend") {
      sortingEnumKey = "-port";
    }
    if (sortField === "total_value" && sortOrder === "ascend") {
      sortingEnumKey = "total_value";
    }
    if (sortField === "total_value" && sortOrder === "descend") {
      sortingEnumKey = "-total_value";
    }
    if (sortField === "goods_currency" && sortOrder === "ascend") {
      sortingEnumKey = "goods_currency";
    }
    if (sortField === "goods_currency" && sortOrder === "descend") {
      sortingEnumKey = "-goods_currency";
    }
    if (sortField === "sac" && sortOrder === "ascend") {
      sortingEnumKey = "sac";
    }
    if (sortField === "sac" && sortOrder === "descend") {
      sortingEnumKey = "-sac";
    }
    if (sortField === "sub_master" && sortOrder === "ascend") {
      sortingEnumKey = "sub_master";
    }
    if (sortField === "sub_master" && sortOrder === "descend") {
      sortingEnumKey = "-sub_master";
    }
    if (sortField === "pkg_type" && sortOrder === "ascend") {
      sortingEnumKey = "pkg_type";
    }
    if (sortField === "pkg_type" && sortOrder === "descend") {
      sortingEnumKey = "-pkg_type";
    }
    if (sortField === "cyber_vendor_account" && sortOrder === "ascend") {
      sortingEnumKey = "cyber_vendor_account";
    }
    if (sortField === "cyber_vendor_account" && sortOrder === "descend") {
      sortingEnumKey = "-cyber_vendor_account";
    }
    if (sortField === "customs_code" && sortOrder === "ascend") {
      sortingEnumKey = "customs_code";
    }
    if (sortField === "customs_code" && sortOrder === "descend") {
      sortingEnumKey = "-customs_code";
    }
    if (sortField === "fr_reference" && sortOrder === "ascend") {
      sortingEnumKey = "fr_reference";
    }
    if (sortField === "fr_reference" && sortOrder === "descend") {
      sortingEnumKey = "-fr_reference";
    }
    return sortingEnumKey;
  };

  const handleReset = () => {
    setState({
      ...state,

      page: 1,
      search: "",
      pagesize: state?.pagesize,
    });
    // setState({
    //   ...state,
    //   search: "",
    //   status: "",
    //   page: 1,
    // });
    form.setFieldsValue({ search: "" });
    latestSearchTerm.current = "";
  };

  const handleApplyFilter = async () => {
    setBtnFilterLoading(true);
    setState({
      // ...state,
      page: 1,
      ordering: "-id",
      pagesize: state?.pagesize,
      search: "",
      total: 0,
    });
    form.setFieldsValue({ search: "" });
    latestSearchTerm.current = "";
  };

  const handleStartDateChange = (date) => {
    if (date) {
      const formattedDate = moment(date).format("DD-MM-YYYY");
      setStartDate(formattedDate);
    } else {
      // When date is cleared
      setStartDate(null);
      // Optionally call your API to clear the date
      clearDateFromAPI();
    }
  };
    const handleEndDateChange = (date) => {
      if (date) {
      const formattedDate = moment(date).format("DD-MM-YYYY");
      setEndDate(formattedDate);}
      else {
        // When date is cleared
        setEndDate(null);
        // Optionally call your API to clear the date
        clearDateFromAPI();
      }
    };
  const minEndDate = startDate
    ? moment(startDate, "DD-MM-YYYY").startOf("day")
    : null;
  const clearDateFromAPI = async () => {
    setLoading(true);

    // Prepare the query parameters
    const queryParamsObject = {
      ...state,
      // start_date: null, // Set to null since we're clearing the date
      // end_date: null,
      is_scanned: checked || null,
      is_picked_up: checkedPickedUp || null,
      // unrouted: checked || null,
      unrouted: checkedRouted || null,
      state: stateFilter?.state || null,
      driver_id: stateFilter?.driver_id || null,
      company_id: stateFilter?.company_id || null,
      page: state.page,
      ordering: state.ordering,
      pagesize: state.pagesize,
      search: state.search,
      total: state.total,
      status: "Received in Depo",
    };

    // Filter out null or undefined values
    const queryParams = new URLSearchParams(
      Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    const payload = {
      // zone_id: stateFilter?.zone_id || [],
      // suburb_id: stateFilter?.suburb_id || [],
      // postcode_name: stateFilter?.postcode_name || [],
      start_date: null,
      end_date: null,
      is_supervisor:true,
      ...(hasPermission === "Supervisor"
        ? { suburb_ids: stateFilter?.suburb_id || [] }
        : { suburb_id: stateFilter?.suburb_id || [] }),
        ...(hasPermission === "Supervisor"
          ? { pincode_ids: stateFilter?.postcode_name || [] }
          : { postcode_name: stateFilter?.postcode_name || [] }),
          ...(hasPermission === "Supervisor"
            ? { zone_ids: stateFilter?.zone_id || [] }
            : { zone_id: stateFilter?.zone_id || [],}),
    };

    try {
       const url =
      hasPermission === "Supervisor"
        ? `package-model/filtered-list/?company_id=${CompanyId}&pickup_point_id=${PickupPointId}&warehouse_id=${WarehouseId}&is_picked_up=true&${queryParams}`
        : `package-model/?company_id=${CompanyId}&pickup_point_id=${PickupPointId}&warehouse_id=${WarehouseId}&is_picked_up=true&${queryParams}`;
            // const apiResponse = await patchRequest(
            //   `package-model/?company_id=${CompanyId}&pickup_point_id=${PickupPointId}&warehouse_id=${WarehouseId}&is_picked_up=${true}&${queryParams}`,
            //   payload
            // );
            const apiResponse = await patchRequest(url, payload);

      if (apiResponse.data.results.success) {
        setEmployeeList(apiResponse.data.results.data);
        settotalCount(apiResponse.data.count);
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error fetching employee list"));
    } finally {
      setLoading(false);
    }
  };

  const handleResetFilter = () => {
    setState({
      // ...state,
      page: 1,
      ordering: "-id",
      pagesize: state?.pagesize,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);
    // setState({
    //   ...state,
    //   search: "",
    //   status: "",
    //   page: 1,
    // });
    form.setFieldsValue({ search: "" });
    latestSearchTerm.current = "";
    setStartDate(null);
    setEndDate(null);
    setChecked(false);
    setCheckedRouted("False");
    setZones([]);
    setSuburbList([]);
    setPostalList([]);
    setZones([]);
    setSelectedStatus(null);
    // setCheckedRouted();
    // setStates([]);
    formRef.current.setFieldsValue({
      state: undefined, // Set to undefined to keep placeholder
      zone: undefined, // Set to undefined to keep placeholder
      // zone: undefined,   // Set to undefined to keep placeholder
      // suburb: undefined, // Set to undefined to keep placeholder
      start_date: undefined,
      end_date: undefined,
      driver_id: undefined,
      company_id: undefined,
      is_scanned: false,
      is_picked_up: false,
      // unrouted: "False",
      unrouted: false,
      postcode: undefined,
      suburb_id: undefined,
      status: null,
      // suburb: response.data.results.data.country_name,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    latestSearchTerm.current = value; 
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
  };
  const handleCheckboxChangePickedUp = (e) => {
    setCheckedPickedUp(e.target.checked);
  };
  const handleCheckboxChangeRouted = (e) => {
    const isChecked = e.target.checked; // Get the checked state (true/false)

    // Set the state to the corresponding string value
    setCheckedRouted(isChecked ? "True" : "False");
  };

  // const rowSelection = {
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     if (selectedRowKeys.length === 0) {
  //       driverForm.resetFields(); // Reset the driver form fields
  //     }
  //     // Calculate total price when selection changes
  //     calculateTotalPrice(selectedRowKeys);
  //   },
  //   onSelect: (record, selected, selectedRows) => {
  //     const updatedSelectedRowKeys = selected
  //       ? [...selectedRow, record.id]
  //       : selectedRow?.filter((key) => key !== record.id);
  //     // Filter out null and remove duplicates from route_id
  //     const updatedPostCodes = selected
  //       ? [...routeIds, record.route_id]
  //       : routeIds.filter((code) => code !== record.route_id);
  //     // Ensure no null and no duplicate route_ids
  //     const uniquePostCodes = [
  //       ...new Set(updatedPostCodes.filter((code) => code !== null)),
  //     ];

  //     setSelectedRow(updatedSelectedRowKeys);
  //     setRouteIds(uniquePostCodes); // Store postcodes
  //     setSelectedRecords(selectedRows); // Store full record objects

  //     const hasSelectedRows = selectedRows?.length > 0;

  //     if (updatedSelectedRowKeys?.length === 0) {
  //       driverForm.resetFields(); // Reset the driver form fields
  //     }
  //   },
  //   onSelectAll: (selected, selectedRows, changeRows) => {
  //     const updatedSelectedRowKeys = selected
  //       ? [...selectedRow, ...changeRows.map((row) => row.id)]
  //       : selectedRow?.filter(
  //           (key) => !changeRows.find((row) => row.id === key)
  //         );
  //     const updatedPostCodes = selected
  //       ? [...routeIds, ...changeRows.map((row) => row.route_id)]
  //       : routeIds.filter(
  //           (code) => !changeRows.find((row) => row.route_id === code)
  //         );

  //     // Ensure no null and no duplicate route_ids
  //     const uniquePostCodes = [
  //       ...new Set(updatedPostCodes.filter((code) => code !== null)),
  //     ];

  //     setRouteIds(uniquePostCodes); // Store only unique and non-null route_ids
  //     setSelectedRow(updatedSelectedRowKeys);
  //     setSelectedRecords(selectedRows); // Store full record objects

  //     // const hasSelectedRows = selectedRows?.length > 0;
  //     // const shouldEnableAddRouteButton =
  //     //   hasSelectedRows &&
  //     //   selectedRows.every(
  //     //     (row) =>
  //     //       row?.is_scanned === true &&

  //     //       (row?.parcel_no === null || row?.parcel_no === 0)
  //     //   );
  //     // setShowAddRouteButton(!shouldEnableAddRouteButton);
  //     // const allRowsHaveParcelNo = selectedRows?.every(
  //     //   (row) => getTrimmedParcelNo(row?.parcel_no) !== ""
  //     // );
  //     // const allRowsHaveEmptyParcelNo = selectedRows?.every(
  //     //   (row) => getTrimmedParcelNo(row?.parcel_no) === ""
  //     // );

  //     if (updatedSelectedRowKeys?.length === 0) {
  //       driverForm.resetFields(); // Reset the driver form fields
  //     }
  //   },
  //   selectedRowKeys: selectedRow,
  // };

  const rowSelection = useMemo(
    () => ({
      onChange: (selectedRowKeys, selectedRows) => {
        if (selectedRowKeys.length === 0) {
          driverForm.resetFields();
        }
        calculateTotalPrice(selectedRowKeys);
      },
      onSelect: (record, selected, selectedRows) => {
        const updatedSelectedRowKeys = selected
          ? [...selectedRow, record.id]
          : selectedRow.filter((key) => key !== record.id);

        const updatedPostCodes = selected
          ? [...routeIds, record.route_id]
          : routeIds.filter((code) => code !== record.route_id);

        const uniquePostCodes = Array.from(
          new Set(updatedPostCodes.filter(Boolean))
        );

        setSelectedRow(updatedSelectedRowKeys);
        setRouteIds(uniquePostCodes);
        setSelectedRecords(selectedRows);

        if (updatedSelectedRowKeys.length === 0) {
          driverForm.resetFields();
        }
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        const updatedSelectedRowKeys = selected
          ? [...selectedRow, ...changeRows.map((row) => row.id)]
          : selectedRow.filter(
              (key) => !changeRows.some((row) => row.id === key)
            );

        const updatedPostCodes = selected
          ? [...routeIds, ...changeRows.map((row) => row.route_id)]
          : routeIds.filter(
              (code) => !changeRows.some((row) => row.route_id === code)
            );

        const uniquePostCodes = Array.from(
          new Set(updatedPostCodes.filter(Boolean))
        );

        setSelectedRow(updatedSelectedRowKeys);
        setRouteIds(uniquePostCodes);
        setSelectedRecords(selectedRows);

        if (updatedSelectedRowKeys.length === 0) {
          driverForm.resetFields();
        }
      },
      selectedRowKeys: selectedRow,
    }),
    [selectedRow, routeIds, setSelectedRow, setRouteIds, setSelectedRecords]
  );

  const handleArchive = async (id = []) => {
    let ids = [...selectedRow];

    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest(
        "package-model/archive-package-model/",
        {
          deleted: ids,
        }
      );
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          form.setFieldsValue({ search: "" });
          latestSearchTerm.current = "";
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("package_archive_successfully"));

        setSelectedRow([]);
        setRouteIds([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
        form.setFieldsValue({ search: "" });
        latestSearchTerm.current = "";
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
      form.setFieldsValue({ search: "" });
      latestSearchTerm.current = "";
      // ErrorNotificationMsg(error);
    }
  };
  const handleMultipleGenerateLabels = (id = []) => {
    let ids = [...selectedRow];
    if (ids.length === 0 && id) {
      ids.push(id);
    }

    // Navigate and pass only IDs
    // navigate(
    //   "/print-labels",
    //   {
    //     state: { ids },
    //   },
    //   "_blank"
    // );
    // Serialize the data as a query string or URL-safe format
    const encodedData = encodeURIComponent(JSON.stringify(ids));

    // Open new tab with state passed via query param
    window.open(`/print-labels?ids=${encodedData}`, "_blank");
  };
  const handleGenerateLabel = (data) => {
    window.open(`/print-label/${btoa(data.id)}`, "_blank");
  };
  const handleEdit = (id) => {
    //   // setModalKey((prevKey) => !prevKey);
    setpackageId(id);
    //  // showBulkUpload();
  };

  const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);
  const showBulkUpload = () => {
    setIsModalOpenBulk(true);
  };
  const handleOkBulk = () => {
    setIsModalOpenBulk(false);
  };
  const handleCancelBulk = () => {
    setIsModalOpenBulk(false);
  };

  const [isModalOpenBulkExcel, setIsModalOpenBulkExcel] = useState(false);
  const showBulkUploadExcel = () => {
    setIsModalOpenBulkExcel(true);
  };
  const handleOkBulkExcel = () => {
    setIsModalOpenBulkExcel(false);
  };
  const handleCancelBulkExcel = () => {
    setIsModalOpenBulkExcel(false);
  };
  const colors = ["#737373"];

  const downloadCSV = async (id = null) => {
    setBtnLoading(true);
    const endpoint = `api`;
    const fileType = "csv";

    // Create a list of IDs (similar to how we handled archive functionality)
    let ids = [...selectedRow];

    // If `selectedRow` is empty but an `id` is provided, add it to the list
    if (ids.length === 0 && id) {
      ids.push(id);
    }

    // Payload for downloading CSV, including the `id` in the payload
    const payload = {
      packages: ids,
    };

    try {
      // Send request to download the CSV
      const response = await patchRequest(
        `package-model/package-csv-download/`,
        payload
      );
      console.log(response, "res45");

      // Process and download the CSV file
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Package_List_${Date.now()}.${fileType}`;
      link.click();
      link.remove(); // Clean up the DOM element
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        ErrorNotificationMsg(t("file_not_found"));
        setBtnLoading(false);
      } else {
        console.error("Error downloading the file:", error);
        ErrorNotificationMsg(t("error_downloading_file"));
        setBtnLoading(false);
      }
    }
  };

  // VirtualTable component for virtualization with manual selection column
  const VirtualTable = ({
    columns,
    scroll,
    dataSource,
    selectedRow,
    selectedRecords,
    setSelectedRow,
    setSelectedRecords,
    rowKey,
    loading,
    onChange,
    sticky,
  }) => {
    const [tableWidth, setTableWidth] = useState(0);
    const gridRef = useRef();
    const scrollPositionRef = useRef({ left: 0, top: 0 });

    // Memoize mergedColumns to prevent remounts
    const mergedColumns = useMemo(() => {
      let cols = [
        {
          key: "selection",
          width: 60,
          title: () => {
            const allVisibleSelected =
              dataSource.length > 0 &&
              dataSource.every((record) =>
                selectedRow.includes(
                  typeof rowKey === "function" ? rowKey(record) : record[rowKey]
                )
              );
            const someVisibleSelected = dataSource.some((record) =>
              selectedRow.includes(
                typeof rowKey === "function" ? rowKey(record) : record[rowKey]
              )
            );
            return (
              <input
                type="checkbox"
                checked={allVisibleSelected}
                ref={(el) => {
                  if (el)
                    el.indeterminate =
                      !allVisibleSelected && someVisibleSelected;
                }}
                onChange={(e) => {
                  if (e.target.checked) {
                    const newKeys = [
                      ...selectedRow,
                      ...dataSource
                        .map((record) =>
                          typeof rowKey === "function"
                            ? rowKey(record)
                            : record[rowKey]
                        )
                        .filter((key) => !selectedRow.includes(key)),
                    ];
                    const newRecords = [
                      ...selectedRecords,
                      ...dataSource.filter(
                        (record) =>
                          !selectedRow.includes(
                            typeof rowKey === "function"
                              ? rowKey(record)
                              : record[rowKey]
                          )
                      ),
                    ];
                    setSelectedRow(newKeys);

                    setSelectedRecords(newRecords);
                  } else {
                    const visibleKeys = dataSource.map((record) =>
                      typeof rowKey === "function"
                        ? rowKey(record)
                        : record[rowKey]
                    );
                    setSelectedRow(
                      selectedRow.filter((key) => !visibleKeys.includes(key))
                    );
                    setSelectedRecords(
                      selectedRecords.filter(
                        (record) =>
                          !visibleKeys.includes(
                            typeof rowKey === "function"
                              ? rowKey(record)
                              : record[rowKey]
                          )
                      )
                    );
                  }
                }}
              />
            );
          },
          render: (text, record, rowIndex) => {
            const key =
              typeof rowKey === "function" ? rowKey(record) : record[rowKey];
            const checked = selectedRow.includes(key);
            return (
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => {
                  let newSelectedRowKeys, newSelectedRows;
                  if (e.target.checked) {
                    newSelectedRowKeys = [...selectedRow, key];
                    newSelectedRows = [...selectedRecords, record];
                  } else {
                    newSelectedRowKeys = selectedRow.filter((k) => k !== key);
                    newSelectedRows = selectedRecords.filter(
                      (r) =>
                        (typeof rowKey === "function"
                          ? rowKey(r)
                          : r[rowKey]) !== key
                    );
                  }
                  setSelectedRow(newSelectedRowKeys);

                  setSelectedRecords(newSelectedRows);
                }}
              />
            );
          },
        },
        ...columns,
      ];
      const widthColumnCount = cols.filter(({ width }) => !width).length;
      cols = cols.map((column) => {
        if (column.width) return column;
        return { ...column, width: Math.floor(tableWidth / widthColumnCount) };
      });
      return cols;
    }, [
      columns,
      dataSource,
      selectedRow,
      selectedRecords,
      setSelectedRow,
      setSelectedRecords,
      rowKey,
      tableWidth,
    ]);

    useEffect(() => {
      if (gridRef.current) {
        gridRef.current.resetAfterIndices({
          columnIndex: 0,
          shouldForceUpdate: true,
        });
      }
    }, [tableWidth]);

    // Helper to get cell content, supporting custom renderers
    const getCellContent = (column, record, rowIndex) => {
      if (column.render) {
        return column.render(record[column.dataIndex], record, rowIndex);
      }
      return record[column.dataIndex];
    };

    // Ref callback for Grid to restore scroll position on mount
    const gridRefCallback = (node) => {
      if (node) {
        console.log("node", node);
        console.log("scroll-left", scrollPositionRef);
        console.log("scroll-top", scrollPositionRef.current.top);
        gridRef.current = node;
        if (typeof node.scrollTo === "function") {
          node.scrollTo({
            scrollLeft: scrollPositionRef.current.left,
            scrollTop: scrollPositionRef.current.top,
          });
        }
      }
    };

    // Memoize renderVirtualList to prevent remounts
    const renderVirtualList = useCallback(
      (rawData, { scrollbarSize, ref, onScroll }) => {
        return (
          <Grid
            key={`grid-${tableWidth}-${mergedColumns.length}-${dataSource.length}`}
            ref={gridRefCallback}
            columnCount={mergedColumns.length}
            columnWidth={(index) => mergedColumns[index].width}
            height={scroll.y}
            rowCount={rawData.length}
            rowHeight={() => 54}
            width={tableWidth}
            initialScrollLeft={scrollPositionRef.current.left}
            initialScrollTop={scrollPositionRef.current.top}
            onScroll={({ scrollLeft, scrollTop }) => {
              scrollPositionRef.current = { left: scrollLeft, top: scrollTop };
              onScroll({ scrollLeft, scrollTop });
            }}
          >
            {({ columnIndex, rowIndex, style }) => (
              <div
                className="virtual-table-cell"
                // style={{
                //   ...style,
                //   boxSizing: "border-box",
                //   padding: "8px",
                //   borderBottom: "1px solid #f0f0f0",
                //   background: rowIndex % 2 === 0 ? "#fff" : "#fafafa",
                // }}
              >
                {getCellContent(
                  mergedColumns[columnIndex],
                  rawData[rowIndex],
                  rowIndex
                )}
              </div>
            )}
          </Grid>
        );
      },
      [mergedColumns, scroll.y, tableWidth, dataSource.length]
    );

    return (
      <ResizeObserver
        onResize={({ width }) => {
          setTableWidth(width);
        }}
      >
        <Table
          columns={mergedColumns}
          dataSource={dataSource}
          rowSelection={undefined} // handled manually
          rowKey={rowKey}
          loading={loading}
          pagination={false}
          components={{
            body: renderVirtualList,
          }}
          scroll={scroll}
          onChange={onChange}
          sticky={sticky}
        />
      </ResizeObserver>
    );
  };

  VirtualTable.propTypes = {
    columns: PropTypes.array.isRequired,
    scroll: PropTypes.object.isRequired,
    dataSource: PropTypes.array.isRequired,
    selectedRow: PropTypes.array.isRequired,
    selectedRecords: PropTypes.array.isRequired,
    setSelectedRow: PropTypes.func.isRequired,
    setSelectedRecords: PropTypes.func.isRequired,
    rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    loading: PropTypes.bool,
    onChange: PropTypes.func,
    sticky: PropTypes.bool,
  };

  // Prepare columns for VirtualizedTable (add selection column at start)
  const virtualColumns = useMemo(
    () => [
      { key: "selection", title: "", width: 50 },
      ...columns.map((col) => ({ ...col, width: col.width || 120 })),
    ],
    [columns]
  );

  // Update customCellRender to handle blank data and custom renderers correctly
  const customCellRender = useCallback((col, row, rowIndex) => {
    if (col.key === "selection") return null; // handled separately
    if (col.render) {
      // If the column has a render function, use it
      return col.render(
        col.dataIndex ? row[col.dataIndex] : undefined,
        row,
        rowIndex
      );
    }
    // Otherwise, just show the value
    return col.dataIndex ? row[col.dataIndex] : null;
  }, []);

  // Add before the main render/return of PackageList
  const selectionColumn = {
    key: "selection",
    width: 60,
    title: "", // The title will be set in VirtualizedTable
  };

  const columnsWithSelection = useMemo(
    () =>
      columns[0]?.key === "selection" ? columns : [selectionColumn, ...columns],
    [columns]
  );

  // Table and scrollbar dimensions

  const headerHeight = 54;
  const rowHeight = 54;
  const [containerWidth, setContainerWidth] = useState(1200); // You can use ResizeObserver for dynamic width
  const contentHeight = employeeList.length * rowHeight;
  const totalTableWidth = columnsWithSelection.reduce(
    (sum, col) => sum + (col.width || 120),
    0
  );
  const [scrollPosition, setScrollPosition] = useState({ left: 0, top: 0 });

  // Handlers to sync scrollbars with table
  const handleCustomScrollbarScroll = (newScrollTop) => {
    if (gridRef.current && gridRef.current.scrollTo) {
      gridRef.current.scrollTo({ scrollTop: newScrollTop });
    }
  };
  const handleCustomHorizontalScrollbarScroll = (newScrollLeft) => {
    if (gridRef.current && gridRef.current.scrollTo) {
      gridRef.current.scrollTo({ scrollLeft: newScrollLeft });
    }
  };

  const gridRef = useRef();
  const tableContainerRef = useRef(null);

  // Dynamic table height using container ref for robust last-row visibility
  const [tableHeight, setTableHeight] = useState(600);
  useEffect(() => {
    const handleResize = () => {
      if (tableContainerRef.current) {
        const containerHeight = tableContainerRef.current.offsetHeight;
        setTableHeight(containerHeight > 300 ? containerHeight : 300);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="mainwrapper">
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
            <h3>{t("Scanned Package List")}</h3>

              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{t("Scanned Package List")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Space>
              {selectedRow.length > 0 && (
                <Card
                  style={{
                    background: "rgb(255 194 168)",
                    border: "1px solid rgb(252 252 252)",
                    borderRadius: 6,
                    boxShadow: "0 2px 8px rgba(24, 144, 255, 0.08)",
                    padding: "6px 18px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 180,
                    height: 40,
                    marginRight: 12,
                  }}
                  bodyStyle={{
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Title
                    level={5}
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#rgb(8 8 8);",
                    }}
                  >
                    {t("Total Price")}: ${totalPrice.toFixed(2)}
                  </Title>
                </Card>
              )}
              <div className="searchwrp" style={{ height: "36px" }}>
                <Space direction="vertical">
                  <Form form={form}>
                    <Form.Item name="search" initialValue="">
                      <Search
                        // value={state.search}
                        prefix={
                          <img
                            src={SearchIcon}
                            alt="SearchIcon"
                            className="SearchIcon"
                            width={22}
                          />
                        }
                        placeholder={t("pl_search_list")}
                        onChange={searchCallbackDelayed}
                        style={{
                          width: 250,
                        }}
                      />
                    </Form.Item>
                  </Form>
                </Space>
              </div>
              {state?.search ? (
                // <Tooltip title="Reset search">
                <Button
                  className="Savegradiantbtncsv reset-button"
                  type="primary"
                  htmlType="button"
                  onClick={() => handleReset()}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <UndoOutlined style={{ fontSize: "18px", color: "#fff" }} />{" "}
                    Reset
                  </span>
                </Button>
              ) : (
                // </Tooltip>
                ""
              )}

              {authUserData()?.permission.includes(
                "package|add_packagemodel"
              ) && (
                <Button
                  className="Savegradiantbtncsv"
                  type="primary"
                  onClick={() => navigate("/package/add")}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("pl_add_package")}
                </Button>
              )}
              {/* </Tooltip> */}
              {/* )} */}
              <Modal
                className="ModelPopupSec"
                title="Upload File"
                open={isModalOpenBulk}
                onOk={handleOkBulk}
                onCancel={handleCancelBulk}
                closable={false}
                wrapClassName="modal-wrapper"
              >
                <BulkPackageUpload
                  setNewPackageAdded={setNewPackageAdded}
                  newPackageAdded={newPackageAdded}
                  packageId={packageId}
                  handleCancelBulk={handleCancelBulk}
                />
              </Modal>
              <Modal
                className="ModelPopupSec"
                title="Upload Excel File"
                open={isModalOpenBulkExcel}
                onOk={handleOkBulkExcel}
                onCancel={handleCancelBulkExcel}
                closable={false}
                wrapClassName="modal-wrapper"
              >
                <BulkPackageUploadExcel
                  setNewPackageAdded={setNewPackageAdded}
                  newPackageAdded={newPackageAdded}
                  packageId={packageId}
                  handleCancelBulkExcel={handleCancelBulkExcel}
                />
              </Modal>

              <Modal
                // title={<span style={{ color: 'orange', fontWeight: 'bold', textAlign: 'center' }}>Return Package Details</span>}
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#F95C19",
                        fontSize: "25px",
                      }}
                    >
                      {" "}
                      Return Package Details{" "}
                    </span>
                  </div>
                }
                open={isModalVisiblePackageDetails}
                onCancel={handleModalClosePackageDetails}
                onOk={handleOkPackageDetails}
                closable={true}
                width={1000}
              >
                <PackageViewForDepoManager
                  packageDetailsViewNew={packageDetailsView}
                />
              </Modal>

              <Modal
                // className="ModelPopupSec"
                title="HAWB Details"
                open={isModalVisibleHAWB}
                onOk={handleOkHAWB}
                onCancel={handleCancelHAWB}
                closable={true}
                width={1000}
                // wrapClassName="modal-wrapper"
              >
                {hawbData ? (
                  <div>
                    <Row gutter={[18, 16]}>
                      {/* Task Details Section */}
                      <Col span={12}>
                        <Card title="Customer Details">
                          <p>
                            <strong>Company:</strong>{" "}
                            {hawbData?.company_name || "N/A"}
                          </p>
                          <p>
                            <strong>HAWB:</strong> {hawbData?.hawb || "N/A"}
                          </p>
                          <p>
                            <strong>Customer Code:</strong>{" "}
                            {hawbData?.customer_code || "N/A"}
                          </p>
                          <p>
                            <strong>Customer Name:</strong>{" "}
                            {hawbData?.customer_name || "N/A"}
                          </p>
                          <p>
                            <strong>Customer Number:</strong>{" "}
                            {hawbData?.customer_phone || "N/A"}
                          </p>
                          <p>
                            <strong>Customer Email:</strong>{" "}
                            {hawbData?.customer_email || "N/A"}
                          </p>
                          <p>
                            <strong>Parcel No.:</strong>{" "}
                            {hawbData?.parcel_no || "N/A"}
                          </p>
                          <p>
                            <strong>Order No.:</strong>{" "}
                            {hawbData?.order_no || "N/A"}
                          </p>
                          <p>
                            <strong>Status:</strong> {hawbData?.status || "N/A"}
                          </p>
                          <p>
                            <strong>Package Delivery Date:</strong>{" "}
                            {hawbData?.delivery_date || "N/A"}
                          </p>
                          <p>
                            <strong>Is Scanned:</strong>{" "}
                            {hawbData?.is_scanned !== undefined
                              ? hawbData.is_scanned.toString()
                              : "N/A"}
                          </p>
                          <p>
                            <strong>Is Picked Up:</strong>{" "}
                            {hawbData?.is_picked_up !== undefined
                              ? hawbData.is_picked_up.toString()
                              : "N/A"}
                          </p>
                        </Card>
                      </Col>

                      {/* Proof of Completion Section */}
                      <Col span={12}>
                        <Card title="Address Details">
                          <p>
                            <strong>Street Address:</strong>{" "}
                            {hawbData?.customer_address || "N/A"}
                          </p>
                          <p>
                            <strong>Country:</strong>{" "}
                            {hawbData?.country_name || "N/A"}
                          </p>
                          <p>
                            <strong>State:</strong>{" "}
                            {hawbData?.state_name || "N/A"}
                          </p>
                          <p>
                            <strong>Zone:</strong>{" "}
                            {hawbData?.zone_name || "N/A"}
                          </p>
                          <p>
                            <strong>Suburb:</strong>{" "}
                            {hawbData?.suburb_name || "N/A"}
                          </p>
                          <p>
                            <strong>Postcode:</strong>{" "}
                            {hawbData?.postcode_name || "N/A"}
                          </p>
                        </Card>
                      </Col>
                    </Row>
                    <Divider />

                    {/* Package Data Section */}
                    <Row gutter={[18, 16]}>
                      <Col span={12}>
                        <Card title="Package Data">
                          <p>
                            <strong>Description Goods:</strong>{" "}
                            {hawbData?.description_of_goods || "N/A"}
                          </p>
                          <p>
                            <strong>Count:</strong> {hawbData?.count || "N/A"}
                          </p>
                          <p>
                            <strong>Landed:</strong>{" "}
                            {hawbData?.landed !== undefined
                              ? hawbData.landed.toString()
                              : "N/A"}
                          </p>
                          <p>
                            <strong>Weight:</strong> {hawbData?.weight || "N/A"}
                          </p>
                          <p>
                            <strong>Price:</strong> {hawbData?.price || "N/A"}
                          </p>
                          {/* <p>
                            <strong>Height:</strong> {hawbData?.height || "N/A"}
                          </p>
                          <p>
                            <strong>Length:</strong> {hawbData?.length || "N/A"}
                          </p>
                          <p>
                            <strong>Volume Weighted:</strong>{" "}
                            {hawbData?.volume_weighted || "N/A"}
                          </p> */}
                        </Card>
                      </Col>

                      {/* Time Window Section */}
                      <Col span={12}>
                        <Card title="Time Window">
                          <p>
                            <strong>Created Date:</strong>{" "}
                            {hawbData?.created_at || "N/A"}
                          </p>
                        </Card>
                      </Col>

                      {/* Completion Time GPS Location */}
                      <Col span={24}>
                        <Card title="Delivery Location">
                          <p>
                            <EnvironmentOutlined />{" "}
                            {hawbData?.customer_address ||
                              "No location available"}
                          </p>
                          <iframe
                            width="100%"
                            height="150"
                            frameBorder="0"
                            src={`https://www.google.com/maps?q=${hawbData?.coordinates?.latitude},${hawbData?.coordinates?.longitude}&hl=es;z=14&output=embed`}
                            allowFullScreen
                          />
                        </Card>
                      </Col>
                      {/* </Row> */}
                    </Row>
                    <Divider />
                  </div>
                ) : (
                  <p>Loading...</p>
                )}
              </Modal>

              {authUserData()?.permission.includes(
                "package|delete_packagemodel"
              ) && (
                <>
                  {selectedRow.length > 0 && (
                    <Popconfirm
                      className="action"
                      title={t("pop_title")}
                      okText={t("pop_ok")}
                      cancelText={t("pop_cancel")}
                      placement="left"
                      onConfirm={() => handleArchive()}
                    >
                      <ButtonField
                        className="Savegradiantbtncsv"
                        type="primary"
                        htmlType="button"
                        label={
                          <>
                            <div
                              className="BlueShadowBtn"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <ArchiveButtonicon />
                              <span>{t("pl_archive")}</span>
                            </div>
                          </>
                        }
                      />
                    </Popconfirm>
                  )}
                </>
              )}

              {authUserData()?.permission.includes(
                "package|add_packagemodel"
              ) && (
                // <Tooltip placement="topLeft" title="CSV Upload">

                <ButtonField
                  className="Savegradiantbtncsv"
                  type="primary"
                  htmlType="primary"
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                      }}
                    >
                      <UploadOutlined style={{ fontSize: "16px" }} />
                      Upload CSV
                    </span>
                  }
                  onClick={showBulkUpload}
                />
                // </Tooltip>
              )}
              {authUserData()?.permission.includes(
                "package|add_packagemodel"
              ) && (
                // <Tooltip placement="topLeft" title="Excel Upload">
                <ButtonField
                  className="Savegradiantbtncsv"
                  type="primary"
                  htmlType="primary"
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                      }}
                    >
                      <UploadOutlined style={{ fontSize: "16px" }} /> Upload
                      Excel
                    </span>
                  }
                  onClick={showBulkUploadExcel}
                  // disabled={!checked || btnLoading}
                />
                // </Tooltip>
              )}
              {authUserData()?.permission.includes(
                "package|delete_packagemodel"
              ) && (
                // <Tooltip placement="topLeft" title="View Archived Records">
                <Link className="Archiveicon" to="/package/archive">
                  <Archiveicon />
                </Link>
                // </Tooltip>
              )}
              <div className="gridiconswrap">
                {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
                <Dropdown
                  overlay={columnMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={(visible) => setDropdownVisible(visible)}
                >
                  <Button
                    type="primary"
                    shape="circle"
                    icon={<InsertRowLeftOutlined />}
                    // onClick={(e) => e.preventDefault()}
                    onClick={() => setDropdownVisible(!dropdownVisible)}
                  />
                </Dropdown>
                {/* </Tooltip> */}
              </div>
            </Space>
            {/* {authUserData()?.permission.includes("employee|add_employee") && (
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  onClick={() => navigate("/employee/add")}
                  icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                >
                  {t("pl_add_employee")}
                </Button>
              )} */}
          </div>
        </div>
        <section className="grid-sec">
          <div className="Package-body">
            {/* Sticky filter/action bar with collapse */}

            <Collapse
              className="filter-collapse"
              defaultActiveKey={["1"]}
              ghost
            >
              <Panel header={<span>Filters</span>} key="1">
                <div className="filterrow packagefilter">
                  {/* ...your filter form JSX here... */}
                  {/* (Move your filter form JSX here from previous code) */}
                  <Form
                    autoComplete="off"
                    ref={formRef}
                    layout="vertical"
                    style={{ width: "100%", margin: 0 }}
                  >
                    <Space wrap size={[16, 10]}>
                      {/* All filter Cols remain unchanged, but spacing is now handled by parent */}

                      {/* <Form.Item name="created_date" label={t("Schedule Date")}>
                        <DatePicker
                          format="DD-MM-YYYY"
                          placeholder="Select Date"
                          value={
                            startDate ? moment(startDate, "DD-MM-YYYY") : null
                          }
                          allowClear={true}
                          style={{ width: 120 }}
                          size="small"
                          onChange={handleStartDateChange}
                        />
                      </Form.Item> */}
   <Form.Item
                      name="start_date"
                      label={t("pl_min_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_start_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleStartDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("statr_date")}
                      />
                    </Form.Item>
              
                    <Form.Item
                      name="end_date"
                      label={t("pl_max_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_end_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleEndDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("end_date")}
                        disabled={!startDate}
                        disabledDate={(current) =>
                          current && (minEndDate ? current < minEndDate : false)
                        }
                      />
                    </Form.Item>
                      <Form.Item
                        className="BrowsButtonSec"
                        label={t("pl_is_scanned")}
                        name="is_scanned"
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={handleCheckboxChange}
                          checked={checked}
                          size="small"
                        ></Checkbox>
                      </Form.Item>

                      <Form.Item
                        className="BrowsButtonSec"
                        label={t("pl_is_picked_up")}
                        name="is_picked_up"
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={handleCheckboxChangePickedUp}
                          checked={checkedPickedUp}
                          size="small"
                        ></Checkbox>
                      </Form.Item>

                      {hasPermission === "Pickup Point Manager" ? null : (
                        <Form.Item
                          className="BrowsButtonSec"
                          label={t("Unrouted")}
                          name="unrouted"
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={handleCheckboxChangeRouted}
                            checked={checkedRouted === "True"}
                            size="small"
                          ></Checkbox>
                        </Form.Item>
                      )}

                      <Form.Item name="state" label={t("pl_state")}>
                        <Select
                          name="state"
                          label={t("pl_state")}
                          placeholder={"Select State"}
                          value={state.state}
                          onChange={handleStateSelectChange}
                          showArrow
                          showSearch
                          optionFilterProp="children"
                          style={{ width: "140px" }}
                          size="small"
                        >
                          {states.map((state) => (
                            <Option key={state.id} value={state.id}>
                              {state.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item name="zone" label={t("pl_zone")}>
                        <Select
                          name="zone"
                          label={t("pl_zone")}
                          placeholder="Select Zone"
                          onChange={handlezoneChange}
                          value={state.zone}
                          showArrow
                          optionFilterProp="children"
                          mode="multiple"
                          showSearch
                          size="small"
                          style={{ width: "100px" }}
                        >
                          {zones?.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.zone}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item name="suburb_id" label={t("Suburb")}>
                        <Select
                          placeholder="Select Suburb"
                          name="suburb_id"
                          value={stateFilter.suburb_id}
                          showArrow
                          onChange={handleSuburbChange}
                          mode="multiple"
                          showSearch
                          optionFilterProp="children"
                          loading={loadingSuburb}
                          disabled={loadingSuburb}
                          style={{ width: "170px" }}
                          size="small"
                        >
                          {suburbList?.map((suburb) => (
                            <Option
                              key={suburb.suburb_id}
                              value={suburb.suburb_id}
                            >
                              {suburb.suburb_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item name="postcode" label={t("pl_postal")}>
                        <Select
                          placeholder={t("pl_select_postal")}
                          name="postcode"
                          value={state.postcode}
                          showArrow
                          onChange={handlePostalChange}
                          mode="multiple"
                          showSearch
                          optionFilterProp="children"
                          style={{ width: "125px" }}
                          loading={loadingPostal}
                          disabled={loadingPostal}
                          size="small"
                        >
                          {postalList?.map((postal) => (
                            <Option
                              key={postal.postcode_id}
                              value={postal.postcode_name}
                            >
                              {postal.postcode_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      {hasPermission === "Company Admin" ||
                      hasPermission === "Pickup Point Manager" ||
                      hasPermission === "Depo Manager" ? null : (
                        <Form.Item name="driver_id" label={t("pl_driver")}>
                          <Select
                            placeholder={t("val_driver")}
                            showArrow
                            showSearch
                            style={{ width: "170px" }}
                            name="driver_id"
                            optionFilterProp="children"
                            onChange={(value) => handleDriverFilter(value)}
                            size="small"
                          >
                            {driverList?.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      )}
                      {hasPermission === "Company Admin" ||
                      hasPermission === "Pickup Point Manager" ||
                      hasPermission === "Depo Manager" ? null : (
                        <Form.Item name="company_id" label={t("pl_company")}>
                          <Select
                            placeholder={t("val_company")}
                            showArrow
                            showSearch
                            style={{ width: "170px" }}
                            name="company_id"
                            optionFilterProp="children"
                            onChange={(value) => handleCompanyFilter(value)}
                            size="small"
                          >
                            {companyList?.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.company_name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      )}
                      {/* {hasPermission === "Depo Manager" ? null : (
                        <Form.Item name="status" label={t("Status")}>
                          <Select
                            className="gridselect"
                            onChange={(value) =>
                              handleResidentSelectChangeStatusFilter(value)
                            }
                            placeholder={t("Select Status")}
                            style={{ width: "200px" }}
                            size="small"
                          >
                            <Option value="Not Scanned">Not Scanned</Option>
                            <Option value="Picked Up">Picked Up</Option>
                            <Option value="Received in Depo">
                              Received in Depo
                            </Option>
                            <Option value="In Transit">In Transit</Option>
                            <Option value="Loaded by Driver">
                              Loaded by Driver
                            </Option>

                            <Option value="Delivered">Delivered</Option>
                            <Option value="Failed Delivery">
                              Failed Delivery
                            </Option>
                            <Option value="Received at Pickup Point">
                              Received at Pickup Point
                            </Option>
                            <Option value="RTS- Return to Sender">
                              RTS- Return to Sender
                            </Option>
                            <Option value="RD- Return to depo">
                              RD- Return to depo
                            </Option>
                            <Option value="Damaged">Damaged</Option>
                            <Option value="Rejected">Rejected</Option>
                            <Option value="Problem Freight">
                              Problem Freight
                            </Option>
                            <Option value="ATL">ATL</Option>
                            
                            <Option value="Received In Perth Depo">
                              Received In Perth Depo
                            </Option>
                            <Option value="Received In Sydney Depo">
                              Received In Sydney Depo
                            </Option>
                            <Option value="Received In Brisbane Depo">
                              Received In Brisbane Depo
                            </Option>
                            <Option value="Received In Canberra Depo">
                              Received In Canberra Depo
                            </Option>
                            <Option value="Received In Adelaide Depo">
                              Received In Adelaide Depo
                            </Option>
                            <Option value="Received In Melbourne Depo">
                              Received In Melbourne Depo
                            </Option>
                          </Select>
                        </Form.Item>
                      )} */}
                    </Space>
                  </Form>
                </div>
              </Panel>
            </Collapse>
            <div className="tblfilterbtn">
              {/* ...your row selection action buttons here... */}
              {/* (Move your row selection action buttons here from previous code) */}
              <Space wrap size={[10, 0]}>
                {/* {endDate || startDate || categoryTreeFilter || rfqStatus ? ( */}
                <>
                  {/* <Tooltip title="Apply Filter"> */}
                  {startDate ||
                  checked ||
                  checkedPickedUp ||
                  checkedRouted === "True" ||
                  stateFilter?.state ||
                  stateFilter?.suburb_id.length !== 0 ||
                  stateFilter?.postcode_name.length !== 0 ||
                  stateFilter?.zone_id.length !== 0 ||
                  selectedStatus ||
                  stateFilter?.driver_id ||
                  stateFilter?.company_id ? (
                    <span>
                      <ButtonField
                        className="SaveGradiantBtn"
                        type="primary"
                        htmlType="Apply"
                        label={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FilterOutlined style={{ fontSize: "16px" }} />{" "}
                            Apply Filter
                          </span>
                        }
                        loading={btnFilterLoading}
                        onClick={handleApplyFilter}
                      />
                    </span>
                  ) : (
                    // </Tooltip>
                    ""
                  )}

                  {/* </Tooltip> */}
                  {startDate ||
                  endDate ||
                  checked ||
                  checkedPickedUp ||
                  checkedRouted === "True" ||
                  stateFilter?.state ||
                  stateFilter?.suburb_id.length !== 0 ||
                  stateFilter?.postcode_name.length !== 0 ||
                  stateFilter?.zone_id.length !== 0 ||
                  selectedStatus ||
                  stateFilter?.driver_id ||
                  stateFilter?.company_id ? (
                    // <Tooltip title="Reset Filter">
                    <span>
                      <ButtonField
                        className="SaveGradiantBtn"
                        type="primary"
                        htmlType="button"
                        label={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <UndoOutlined
                              style={{ fontSize: "18px", color: "#fff" }}
                            />{" "}
                            Reset
                          </span>
                        }
                        onClick={handleResetFilter}
                      />
                    </span>
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </>

                {selectedRow.length > 0 && (
                  // <Tooltip placement="topLeft" title="Assigned To Driver">
                  <>
                    {hasPermission === "Company Admin" ||
                    hasPermission === "Pickup Point Manager" ? null : (
                      <ButtonField
                        className="SaveGradiantBtn"
                        type="primary"
                        htmlType="button" // Use "button" instead of "Reset"
                        label="Assign Packages To Driver"
                        onClick={handleChangeAssign}
                      />
                    )}

                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="button" // Use "button" instead of "Reset"
                      label={
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <DownloadOutlined style={{ fontSize: "16px" }} />{" "}
                          Download CSV
                        </span>
                      }
                      loading={btnLoading}
                      // onClick={handleChangeAssign}
                      onClick={downloadCSV}
                    />
                    {/* {authUserData()?.permission.includes(
                            "package|delete_packagemodel"
                          ) && ( */}
                    <>
                      {selectedRow.length > 0 && (
                        <Popconfirm
                          className="action"
                          title={t("pop_title_print")}
                          okText={t("pop_ok")}
                          cancelText={t("pop_cancel")}
                          placement="left"
                          onConfirm={() => handleMultipleGenerateLabels()}
                        >
                          <ButtonField
                            className="BlueShadowBtn"
                            type="primary"
                            htmlType="button"
                            label={
                              <>
                                <div
                                  className="BlueShadowBtn"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  <PrinterFilled />
                                  <span>{t("Print Labels")}</span>
                                </div>
                              </>
                            }
                          />
                        </Popconfirm>
                      )}
                    </>

                    <Modal
                      title="Confirm Driver Assignment"
                      open={isModalVisible}
                      className="ModelPopupSecAssign"
                      closable={false}
                      wrapClassName="modal-wrapper"
                      keyboard={false}
                      onCancel={closeModal}
                    >
                      <MultipleConfirmDriverAssignment
                        fileList={fileList}
                        setFileList={setFileList}
                        driverList={driverList}
                        setEmployeeList={setEmployeeList}
                        reload={reload}
                        setReload={setReload}
                        closeModal={closeModal}
                        setIsModalVisible={setIsModalVisible}
                        // modalKey={modalKey}
                        record={record}
                        selectedRow={selectedRow}
                        setSelectedRow={setSelectedRow}
                        setRouteIds={setRouteIds}
                        routeIds={routeIds}
                      />
                    </Modal>
                  </>
                  // </Tooltip>
                )}
              </Space>
            </div>

            {/* Fully virtualized table (no AntD Table) */}
            {/* Scroll to End Button */}
            {/* <Button
            style={{ margin: "8px 0", float: "right", zIndex: 20 }}
            onClick={() => {
              if (gridRef.current && gridRef.current.scrollTo) {
                const maxScrollLeft = Math.max(
                  0,
                  totalTableWidth - containerWidth
                );
                const maxScrollTop = Math.max(
                  0,
                  contentHeight - (tableHeight - headerHeight)
                );
                gridRef.current.scrollTo({
                  scrollLeft: maxScrollLeft,
                  scrollTop: maxScrollTop,
                });
              }
            }}
          >
            Scroll to End
          </Button> */}
            <div className="custom-tablewrp" ref={tableContainerRef}>
              <VirtualizedTable
                columns={columnsWithSelection}
                data={employeeList}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                rowKey={(record) => record.id}
                height={tableHeight}
                width={containerWidth}
                rowHeight={rowHeight}
                headerHeight={headerHeight}
                customCellRender={customCellRender}
                loading={loading}
                calculateTotalPrice={calculateTotalPrice}
                sortState={sortState}
                setSortState={setSortState}
                gridRef={gridRef}
                setScrollPosition={setScrollPosition}
                scrollPosition={scrollPosition}
              />
              {/* Custom scrollbars for the table */}
              {/* <VerticalScrollbar
                height={tableHeight - headerHeight}
                contentHeight={contentHeight}
                scrollTop={scrollPosition.top}
                onScroll={handleCustomScrollbarScroll}
              /> */}
              {/* Only render the custom horizontal scrollbar inside VirtualizedTable, not here */}
            </div>
            {/* Sticky Footer (Pagination) */}

            <Pagination
              current={state.page}
              pageSize={state.pagesize}
              total={totalCount}
              showSizeChanger
              pageSizeOptions={[
                "10",
                "50",
                "100",
                "200",
                "300",
                "400",
                "500",
                "1000",
              ]}
              showTotal={(total) => `Total ${total} items`}
              locale={{ items_per_page: "Items / Page" }}
              onChange={(page, pageSize) => {
                setState((prev) => ({
                  ...prev,
                  page,
                  pagesize: pageSize,
                }));
              }}
              style={{ marginTop: 0, textAlign: "right", padding: "8px 0" }}
            />
          </div>
        </section>
      </div>
    </>
  );
};
export default ScannedPackageList;
